var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6900,
    height: 554,
    viewBox: "0 0 6900 554",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2878.44 374.634H2876.73V482.601H2878.44V374.634Z",
    fill: "url(#paint0_linear_7547_125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3966.34 79H3964.63V276.653H3966.34V79Z",
    fill: "url(#paint1_linear_7547_125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2308.71 205H2310.42V402.653H2308.71V205Z",
    fill: "url(#paint2_linear_7547_125)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3940.44 189.634H3938.73V246.233H3940.44V189.634Z",
    fill: "url(#paint3_linear_7547_125)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2334.61 315.634H2336.32V372.233H2334.61V315.634Z",
    fill: "url(#paint4_linear_7547_125)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3914.54 213.54H3912.83V266.654H3914.54V213.54Z",
    fill: "url(#paint5_linear_7547_125)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2360.52 339.539H2362.23V392.654H2360.52V339.539Z",
    fill: "url(#paint6_linear_7547_125)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3888.64 194.043H3886.93V287.208H3888.64V194.043Z",
    fill: "url(#paint7_linear_7547_125)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2386.42 320.043H2388.13V413.208H2386.42V320.043Z",
    fill: "url(#paint8_linear_7547_125)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3862.74 216.78H3861.03V297.323H3862.74V216.78Z",
    fill: "url(#paint9_linear_7547_125)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2412.32 342.78H2414.03V423.323H2412.32V342.78Z",
    fill: "url(#paint10_linear_7547_125)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3836.83 268.118H3835.12V374.347H3836.83V268.118Z",
    fill: "url(#paint11_linear_7547_125)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2438.22 394.118H2439.93V500.347H2438.22V394.118Z",
    fill: "url(#paint12_linear_7547_125)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3810.93 280.544H3809.22V357.17H3810.93V280.544Z",
    fill: "url(#paint13_linear_7547_125)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2464.12 406.544H2465.83V483.17H2464.12V406.544Z",
    fill: "url(#paint14_linear_7547_125)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3785.03 198.023H3783.32V383.486H3785.03V198.023Z",
    fill: "url(#paint15_linear_7547_125)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2490.02 324.023H2491.73V509.486H2490.02V324.023Z",
    fill: "url(#paint16_linear_7547_125)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3759.13 191.222H3757.42V323.137H3759.13V191.222Z",
    fill: "url(#paint17_linear_7547_125)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2515.92 317.222H2517.63V449.137H2515.92V317.222Z",
    fill: "url(#paint18_linear_7547_125)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3733.23 211.943H3731.52V262.447H3733.23V211.943Z",
    fill: "url(#paint19_linear_7547_125)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2541.83 337.943H2543.54V388.447H2541.83V337.943Z",
    fill: "url(#paint20_linear_7547_125)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3707.33 194.278H3705.62V264.805H3707.33V194.278Z",
    fill: "url(#paint21_linear_7547_125)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2567.72 320.278H2569.44V390.805H2567.72V320.278Z",
    fill: "url(#paint22_linear_7547_125)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3681.42 184.416H3679.71V283.245H3681.42V184.416Z",
    fill: "url(#paint23_linear_7547_125)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2593.63 310.416H2595.34V409.245H2593.63V310.416Z",
    fill: "url(#paint24_linear_7547_125)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3655.52 234.475H3653.81V297.164H3655.52V234.475Z",
    fill: "url(#paint25_linear_7547_125)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2619.53 360.475H2621.24V423.164H2619.53V360.475Z",
    fill: "url(#paint26_linear_7547_125)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3629.62 203.84H3627.91V313.55H3629.62V203.84Z",
    fill: "url(#paint27_linear_7547_125)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2645.43 329.84H2647.14V439.55H2645.43V329.84Z",
    fill: "url(#paint28_linear_7547_125)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3603.72 237.424H3602.01V270.074H3603.72V237.424Z",
    fill: "url(#paint29_linear_7547_125)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2671.33 363.424H2673.04V396.074H2671.33V363.424Z",
    fill: "url(#paint30_linear_7547_125)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3577.82 215.487H3576.1V260.546H3577.82V215.487Z",
    fill: "url(#paint31_linear_7547_125)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2697.24 341.487H2698.95V386.546H2697.24V341.487Z",
    fill: "url(#paint32_linear_7547_125)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3551.92 186.132H3550.21V276.251H3551.92V186.132Z",
    fill: "url(#paint33_linear_7547_125)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2723.14 312.132H2724.85V402.251H2723.14V312.132Z",
    fill: "url(#paint34_linear_7547_125)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3526.01 173.369H3524.3V256.959H3526.01V173.369Z",
    fill: "url(#paint35_linear_7547_125)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2749.04 299.369H2750.75V382.959H2749.04V299.369Z",
    fill: "url(#paint36_linear_7547_125)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M3500.11 179.109H3498.4V275.758H3500.11V179.109Z",
    fill: "url(#paint37_linear_7547_125)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2774.94 305.109H2776.65V401.758H2774.94V305.109Z",
    fill: "url(#paint38_linear_7547_125)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3474.21 149.54H3472.5V269.702H3474.21V149.54Z",
    fill: "url(#paint39_linear_7547_125)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2800.84 275.54H2802.55V395.702H2800.84V275.54Z",
    fill: "url(#paint40_linear_7547_125)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3448.31 171.751H3446.6V271.341H3448.31V171.751Z",
    fill: "url(#paint41_linear_7547_125)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2826.77 297.751H2828.48V397.341H2826.77V297.751Z",
    fill: "url(#paint42_linear_7547_125)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3422.41 222.96H3420.7V277.817H3422.41V222.96Z",
    fill: "url(#paint43_linear_7547_125)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2852.67 348.961H2854.38V403.817H2852.67V348.961Z",
    fill: "url(#paint44_linear_7547_125)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3396.51 196.469H3394.79V276.794H3396.51V196.469Z",
    fill: "url(#paint45_linear_7547_125)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3370.6 183.419H3368.89V324.477H3370.6V183.419Z",
    fill: "url(#paint46_linear_7547_125)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3344.7 177.722H3342.99V391.918H3344.7V177.722Z",
    fill: "url(#paint47_linear_7547_125)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3318.77 206.652H3317.06V507.051H3318.77V206.652Z",
    fill: "url(#paint48_linear_7547_125)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3292.86 337.536H3291.15V457.694H3292.86V337.536Z",
    fill: "url(#paint49_linear_7547_125)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3266.97 306.508H3265.25V447.567H3266.97V306.508Z",
    fill: "url(#paint50_linear_7547_125)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3241.06 282.504H3239.35V411.805H3241.06V282.504Z",
    fill: "url(#paint51_linear_7547_125)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3215.16 285.137H3213.45V426.195H3215.16V285.137Z",
    fill: "url(#paint52_linear_7547_125)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M3189.26 282.273H3187.55V344.094H3189.26V282.273Z",
    fill: "url(#paint53_linear_7547_125)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3163.36 265.366H3161.65V397.281H3163.36V265.366Z",
    fill: "url(#paint54_linear_7547_125)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M3137.45 332.413H3135.74V391.186H3137.45V332.413Z",
    fill: "url(#paint55_linear_7547_125)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M3111.56 323.249H3109.84V435.573H3111.56V323.249Z",
    fill: "url(#paint56_linear_7547_125)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3085.65 314.821H3083.94V481.998H3085.65V314.821Z",
    fill: "url(#paint57_linear_7547_125)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3059.75 374.634H3058.04V482.601H3059.75V374.634Z",
    fill: "url(#paint58_linear_7547_125)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3033.85 418.884H3032.14V458.94H3033.85V418.884Z",
    fill: "url(#paint59_linear_7547_125)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3007.95 312.681H3006.24V553H3007.95V312.681Z",
    fill: "url(#paint60_linear_7547_125)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2982.04 375.293H2980.33V457.142H2982.04V375.293Z",
    fill: "url(#paint61_linear_7547_125)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2956.15 355.214H2954.43V518.911H2956.15V355.214Z",
    fill: "url(#paint62_linear_7547_125)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2930.24 370.966H2928.53V536.405H2930.24V370.966Z",
    fill: "url(#paint63_linear_7547_125)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M2904.34 366.193H2902.63V474.161H2904.34V366.193Z",
    fill: "url(#paint64_linear_7547_125)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M2886.15 412.263H2869.02V444.981H2886.15V412.263Z",
    fill: "url(#paint65_linear_7547_125)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M3974.05 147.879H3956.92V207.774H3974.05V147.879Z",
    fill: "url(#paint66_linear_7547_125)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2301 273.879H2318.13V333.774H2301V273.879Z",
    fill: "url(#paint67_linear_7547_125)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M3948.15 209.358H3931.02V226.509H3948.15V209.358Z",
    fill: "url(#paint68_linear_7547_125)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M2326.9 335.358H2344.04V352.509H2326.9V335.358Z",
    fill: "url(#paint69_linear_7547_125)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M3922.25 232.048H3905.12V248.142H3922.25V232.048Z",
    fill: "url(#paint70_linear_7547_125)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M2352.8 358.048H2369.93V374.142H2352.8V358.048Z",
    fill: "url(#paint71_linear_7547_125)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M3896.35 226.509H3879.22V254.742H3896.35V226.509Z",
    fill: "url(#paint72_linear_7547_125)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M2378.71 352.509H2395.84V380.742H2378.71V352.509Z",
    fill: "url(#paint73_linear_7547_125)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M3870.45 244.846H3853.31V269.252H3870.45V244.846Z",
    fill: "url(#paint74_linear_7547_125)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M2404.61 370.846H2421.74V395.252H2404.61V370.846Z",
    fill: "url(#paint75_linear_7547_125)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M3844.55 305.139H3827.42V337.331H3844.55V305.139Z",
    fill: "url(#paint76_linear_7547_125)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M2430.51 431.139H2447.64V463.331H2430.51V431.139Z",
    fill: "url(#paint77_linear_7547_125)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M3818.64 307.249H3801.51V330.47H3818.64V307.249Z",
    fill: "url(#paint78_linear_7547_125)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M2456.41 433.249H2473.54V456.47H2456.41V433.249Z",
    fill: "url(#paint79_linear_7547_125)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M3792.74 262.656H3775.61V318.857H3792.74V262.656Z",
    fill: "url(#paint80_linear_7547_125)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M2482.31 388.656H2499.44V444.857H2482.31V388.656Z",
    fill: "url(#paint81_linear_7547_125)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M3766.84 237.193H3749.71V277.167H3766.84V237.193Z",
    fill: "url(#paint82_linear_7547_125)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M2508.21 363.193H2525.34V403.167H2508.21V363.193Z",
    fill: "url(#paint83_linear_7547_125)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M3740.94 229.539H3723.81V244.846H3740.94V229.539Z",
    fill: "url(#paint84_linear_7547_125)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M2534.11 355.539H2551.25V370.846H2534.11V355.539Z",
    fill: "url(#paint85_linear_7547_125)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M3715.03 218.856H3697.9V240.227H3715.03V218.856Z",
    fill: "url(#paint86_linear_7547_125)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M2560.02 344.856H2577.15V366.227H2560.02V344.856Z",
    fill: "url(#paint87_linear_7547_125)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M3689.14 218.856H3672V248.801H3689.14V218.856Z",
    fill: "url(#paint88_linear_7547_125)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M2585.92 344.856H2603.05V374.801H2585.92V344.856Z",
    fill: "url(#paint89_linear_7547_125)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M3663.23 256.321H3646.1V275.318H3663.23V256.321Z",
    fill: "url(#paint90_linear_7547_125)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M2611.82 382.321H2628.95V401.318H2611.82V382.321Z",
    fill: "url(#paint91_linear_7547_125)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M3637.33 242.076H3620.2V275.322H3637.33V242.076Z",
    fill: "url(#paint92_linear_7547_125)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M2637.72 368.076H2654.85V401.322H2637.72V368.076Z",
    fill: "url(#paint93_linear_7547_125)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M3611.43 248.805H3594.3V258.701H3611.43V248.805Z",
    fill: "url(#paint94_linear_7547_125)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M2663.62 374.805H2680.75V384.701H2663.62V374.805Z",
    fill: "url(#paint95_linear_7547_125)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M3585.53 231.192H3568.4V244.846H3585.53V231.192Z",
    fill: "url(#paint96_linear_7547_125)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2689.52 357.192H2706.66V370.846H2689.52V357.192Z",
    fill: "url(#paint97_linear_7547_125)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M3559.62 217.537H3542.49V244.846H3559.62V217.537Z",
    fill: "url(#paint98_linear_7547_125)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M2715.43 343.537H2732.56V370.846H2715.43V343.537Z",
    fill: "url(#paint99_linear_7547_125)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M3533.73 202.496H3516.59V227.827H3533.73V202.496Z",
    fill: "url(#paint100_linear_7547_125)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M2741.33 328.496H2758.46V353.827H2741.33V328.496Z",
    fill: "url(#paint101_linear_7547_125)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M3507.82 212.786H3490.69V242.072H3507.82V212.786Z",
    fill: "url(#paint102_linear_7547_125)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M2767.23 338.786H2784.36V368.072H2767.23V338.786Z",
    fill: "url(#paint103_linear_7547_125)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M3481.92 191.414H3464.79V227.827H3481.92V191.414Z",
    fill: "url(#paint104_linear_7547_125)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M2793.13 317.414H2810.26V353.827H2793.13V317.414Z",
    fill: "url(#paint105_linear_7547_125)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M3456.02 206.456H3438.89V236.632H3456.02V206.456Z",
    fill: "url(#paint106_linear_7547_125)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M2819.05 332.456H2836.19V362.632H2819.05V332.456Z",
    fill: "url(#paint107_linear_7547_125)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M3430.12 242.076H3412.99V258.697H3430.12V242.076Z",
    fill: "url(#paint108_linear_7547_125)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M2844.96 368.076H2862.09V384.697H2844.96V368.076Z",
    fill: "url(#paint109_linear_7547_125)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M3404.22 224.463H3387.09V248.805H3404.22V224.463Z",
    fill: "url(#paint110_linear_7547_125)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M3378.32 232.574H3361.18V275.318H3378.32V232.574Z",
    fill: "url(#paint111_linear_7547_125)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M3352.41 252.366H3335.28V317.273H3352.41V252.366Z",
    fill: "url(#paint112_linear_7547_125)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M3326.48 311.337H3309.35V402.366H3326.48V311.337Z",
    fill: "url(#paint113_linear_7547_125)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M3300.58 379.411H3283.45V415.824H3300.58V379.411Z",
    fill: "url(#paint114_linear_7547_125)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M3274.67 355.664H3257.54V398.407H3274.67V355.664Z",
    fill: "url(#paint115_linear_7547_125)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3248.78 327.563H3231.64V366.746H3248.78V327.563Z",
    fill: "url(#paint116_linear_7547_125)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M3222.87 334.292H3205.74V377.035H3222.87V334.292Z",
    fill: "url(#paint117_linear_7547_125)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M4589.88 230.544H4588.17V307.17H4589.88V230.544Z",
    fill: "url(#paint118_linear_7547_125)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M4563.98 148.023H4562.27V333.486H4563.98V148.023Z",
    fill: "url(#paint119_linear_7547_125)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M4538.08 141.222H4536.37V273.137H4538.08V141.222Z",
    fill: "url(#paint120_linear_7547_125)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M4512.17 161.943H4510.46V212.447H4512.17V161.943Z",
    fill: "url(#paint121_linear_7547_125)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M4486.27 144.278H4484.56V214.805H4486.27V144.278Z",
    fill: "url(#paint122_linear_7547_125)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M4460.37 134.416H4458.66V233.245H4460.37V134.416Z",
    fill: "url(#paint123_linear_7547_125)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M4434.47 184.475H4432.76V247.164H4434.47V184.475Z",
    fill: "url(#paint124_linear_7547_125)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M4408.57 153.84H4406.86V263.55H4408.57V153.84Z",
    fill: "url(#paint125_linear_7547_125)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M4382.66 187.424H4380.95V220.074H4382.66V187.424Z",
    fill: "url(#paint126_linear_7547_125)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M4356.76 165.487H4355.05V210.546H4356.76V165.487Z",
    fill: "url(#paint127_linear_7547_125)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M4330.92 136.132H4329.21V226.251H4330.92V136.132Z",
    fill: "url(#paint128_linear_7547_125)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M4305.01 123.369H4303.3V206.959H4305.01V123.369Z",
    fill: "url(#paint129_linear_7547_125)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M4279.11 129.109H4277.4V225.758H4279.11V129.109Z",
    fill: "url(#paint130_linear_7547_125)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M4253.21 99.5399H4251.5V219.702H4253.21V99.5399Z",
    fill: "url(#paint131_linear_7547_125)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M4227.31 121.751H4225.6V221.341H4227.31V121.751Z",
    fill: "url(#paint132_linear_7547_125)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M4201.41 172.96H4199.7V227.817H4201.41V172.96Z",
    fill: "url(#paint133_linear_7547_125)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M4175.51 146.469H4173.79V226.794H4175.51V146.469Z",
    fill: "url(#paint134_linear_7547_125)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M4149.6 133.419H4147.89V274.477H4149.6V133.419Z",
    fill: "url(#paint135_linear_7547_125)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M4123.7 127.722H4121.99V341.918H4123.7V127.722Z",
    fill: "url(#paint136_linear_7547_125)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M4097.8 156.652H4096.09V457.051H4097.8V156.652Z",
    fill: "url(#paint137_linear_7547_125)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M4071.9 287.536H4070.19V407.694H4071.9V287.536Z",
    fill: "url(#paint138_linear_7547_125)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M4046 256.508H4044.29V397.567H4046V256.508Z",
    fill: "url(#paint139_linear_7547_125)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M4020.1 232.504H4018.38V361.805H4020.1V232.504Z",
    fill: "url(#paint140_linear_7547_125)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M3994.19 235.137H3992.48V376.195H3994.19V235.137Z",
    fill: "url(#paint141_linear_7547_125)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M4597.59 257.249H4580.46V280.47H4597.59V257.249Z",
    fill: "url(#paint142_linear_7547_125)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M4571.69 212.656H4554.55V268.857H4571.69V212.656Z",
    fill: "url(#paint143_linear_7547_125)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4545.79 187.193H4528.66V227.167H4545.79V187.193Z",
    fill: "url(#paint144_linear_7547_125)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M4519.88 179.539H4502.75V194.846H4519.88V179.539Z",
    fill: "url(#paint145_linear_7547_125)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M4493.98 168.856H4476.85V190.227H4493.98V168.856Z",
    fill: "url(#paint146_linear_7547_125)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M4468.08 168.856H4450.95V198.801H4468.08V168.856Z",
    fill: "url(#paint147_linear_7547_125)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M4442.18 206.321H4425.05V225.318H4442.18V206.321Z",
    fill: "url(#paint148_linear_7547_125)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M4416.28 192.076H4399.14V225.322H4416.28V192.076Z",
    fill: "url(#paint149_linear_7547_125)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M4390.38 198.805H4373.25V208.701H4390.38V198.805Z",
    fill: "url(#paint150_linear_7547_125)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M4364.53 181.192H4347.4V194.846H4364.53V181.192Z",
    fill: "url(#paint151_linear_7547_125)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M4338.62 167.537H4321.49V194.846H4338.62V167.537Z",
    fill: "url(#paint152_linear_7547_125)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M4312.73 152.496H4295.59V177.827H4312.73V152.496Z",
    fill: "url(#paint153_linear_7547_125)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M4286.82 162.786H4269.69V192.072H4286.82V162.786Z",
    fill: "url(#paint154_linear_7547_125)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M4260.92 141.414H4243.79V177.827H4260.92V141.414Z",
    fill: "url(#paint155_linear_7547_125)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M4235.02 156.456H4217.89V186.632H4235.02V156.456Z",
    fill: "url(#paint156_linear_7547_125)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M4209.12 192.076H4191.99V208.697H4209.12V192.076Z",
    fill: "url(#paint157_linear_7547_125)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M4183.22 174.463H4166.09V198.805H4183.22V174.463Z",
    fill: "url(#paint158_linear_7547_125)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M4157.32 182.574H4140.18V225.318H4157.32V182.574Z",
    fill: "url(#paint159_linear_7547_125)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M4131.41 202.366H4114.28V267.273H4131.41V202.366Z",
    fill: "url(#paint160_linear_7547_125)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M4105.51 261.337H4088.38V352.366H4105.51V261.337Z",
    fill: "url(#paint161_linear_7547_125)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M4079.61 329.411H4062.48V365.824H4079.61V329.411Z",
    fill: "url(#paint162_linear_7547_125)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M4053.71 305.664H4036.58V348.407H4053.71V305.664Z",
    fill: "url(#paint163_linear_7547_125)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M4027.81 277.563H4010.68V316.746H4027.81V277.563Z",
    fill: "url(#paint164_linear_7547_125)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M4001.91 284.292H3984.77V327.035H4001.91V284.292Z",
    fill: "url(#paint165_linear_7547_125)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M3196.97 303.816H3179.84V322.551H3196.97V303.816Z",
    fill: "url(#paint166_linear_7547_125)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M3171.07 311.337H3153.94V351.311H3171.07V311.337Z",
    fill: "url(#paint167_linear_7547_125)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M3145.17 352.894H3128.04V370.705H3145.17V352.894Z",
    fill: "url(#paint168_linear_7547_125)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M3119.26 362.392H3102.13V396.43H3119.26V362.392Z",
    fill: "url(#paint169_linear_7547_125)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M3093.36 373.08H3076.23V423.738H3093.36V373.08Z",
    fill: "url(#paint170_linear_7547_125)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M3067.46 412.263H3050.33V444.981H3067.46V412.263Z",
    fill: "url(#paint171_linear_7547_125)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M3041.56 432.842H3024.43V444.981H3041.56V432.842Z",
    fill: "url(#paint172_linear_7547_125)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M3015.66 396.43H2998.53V469.255H3015.66V396.43Z",
    fill: "url(#paint173_linear_7547_125)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M2989.76 403.818H2972.62V428.618H2989.76V403.818Z",
    fill: "url(#paint174_linear_7547_125)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M2963.85 412.263H2946.72V461.867H2963.85V412.263Z",
    fill: "url(#paint175_linear_7547_125)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M2937.95 428.622H2920.82V478.753H2937.95V428.622Z",
    fill: "url(#paint176_linear_7547_125)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M2912.06 403.818H2894.92V436.536H2912.06V403.818Z",
    fill: "url(#paint177_linear_7547_125)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M577.437 375.094H575.727V483.061H577.437V375.094Z",
    fill: "url(#paint178_linear_7547_125)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1665.34 19.4601H1663.63V217.113H1665.34V19.4601Z",
    fill: "url(#paint179_linear_7547_125)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71325 205.46H9.42383V403.113H7.71325V205.46Z",
    fill: "url(#paint180_linear_7547_125)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1639.44 190.094H1637.73V246.693H1639.44V190.094Z",
    fill: "url(#paint181_linear_7547_125)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6117 316.094H35.3223V372.693H33.6117V316.094Z",
    fill: "url(#paint182_linear_7547_125)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.54 214H1611.83V267.114H1613.54V214Z",
    fill: "url(#paint183_linear_7547_125)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M59.515 340H61.2256V393.114H59.515V340Z",
    fill: "url(#paint184_linear_7547_125)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.63 194.503H1585.92V287.668H1587.63V194.503Z",
    fill: "url(#paint185_linear_7547_125)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4183 320.503H87.1289V413.668H85.4183V320.503Z",
    fill: "url(#paint186_linear_7547_125)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.73 217.24H1560.02V297.783H1561.73V217.24Z",
    fill: "url(#paint187_linear_7547_125)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M111.317 343.24H113.027V423.783H111.317V343.24Z",
    fill: "url(#paint188_linear_7547_125)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.83 268.578H1534.12V374.807H1535.83V268.578Z",
    fill: "url(#paint189_linear_7547_125)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M137.218 394.578H138.929V500.807H137.218V394.578Z",
    fill: "url(#paint190_linear_7547_125)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1509.93 281.004H1508.22V357.63H1509.93V281.004Z",
    fill: "url(#paint191_linear_7547_125)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M163.121 407.004H164.832V483.63H163.121V407.004Z",
    fill: "url(#paint192_linear_7547_125)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1484.03 198.483H1482.32V383.946H1484.03V198.483Z",
    fill: "url(#paint193_linear_7547_125)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M189.021 324.483H190.731V509.946H189.021V324.483Z",
    fill: "url(#paint194_linear_7547_125)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.13 191.682H1456.42V323.598H1458.13V191.682Z",
    fill: "url(#paint195_linear_7547_125)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M214.923 177.682H216.634V309.598H214.923V177.682Z",
    fill: "url(#paint196_linear_7547_125)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1432.22 212.403H1430.51V262.907H1432.22V212.403Z",
    fill: "url(#paint197_linear_7547_125)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M240.827 268.403H242.537V318.907H240.827V268.403Z",
    fill: "url(#paint198_linear_7547_125)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.32 194.738H1404.61V265.265H1406.32V194.738Z",
    fill: "url(#paint199_linear_7547_125)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M266.726 320.738H268.437V391.265H266.726V320.738Z",
    fill: "url(#paint200_linear_7547_125)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.42 184.876H1378.71V283.705H1380.42V184.876Z",
    fill: "url(#paint201_linear_7547_125)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M292.629 310.876H294.34V409.705H292.629V310.876Z",
    fill: "url(#paint202_linear_7547_125)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1354.52 234.935H1352.81V297.624H1354.52V234.935Z",
    fill: "url(#paint203_linear_7547_125)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M318.532 360.935H320.242V423.624H318.532V360.935Z",
    fill: "url(#paint204_linear_7547_125)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M344.431 330.3H346.142V440.01H344.431V330.3Z",
    fill: "url(#paint205_linear_7547_125)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M370.334 363.884H372.045V396.534H370.334V363.884Z",
    fill: "url(#paint206_linear_7547_125)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M396.237 341.947H397.947V387.006H396.237V341.947Z",
    fill: "url(#paint207_linear_7547_125)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M422.136 312.593H423.847V402.711H422.136V312.593Z",
    fill: "url(#paint208_linear_7547_125)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M448.039 299.829H449.75V383.419H448.039V299.829Z",
    fill: "url(#paint209_linear_7547_125)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M473.938 305.569H475.648V402.219H473.938V305.569Z",
    fill: "url(#paint210_linear_7547_125)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M499.841 196H501.552V316.162H499.841V196Z",
    fill: "url(#paint211_linear_7547_125)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M525.764 268.211H527.475V367.801H525.764V268.211Z",
    fill: "url(#paint212_linear_7547_125)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M551.662 349.421H553.373V404.277H551.662V349.421Z",
    fill: "url(#paint213_linear_7547_125)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M836.452 332.873H834.741V391.646H836.452V332.873Z",
    fill: "url(#paint214_linear_7547_125)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M810.552 323.709H808.842V436.033H810.552V323.709Z",
    fill: "url(#paint215_linear_7547_125)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M784.65 315.281H782.939V482.458H784.65V315.281Z",
    fill: "url(#paint216_linear_7547_125)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M758.746 375.094H757.035V483.061H758.746V375.094Z",
    fill: "url(#paint217_linear_7547_125)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M732.847 419.344H731.137V459.4H732.847V419.344Z",
    fill: "url(#paint218_linear_7547_125)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M706.945 313.141H705.234V553.46H706.945V313.141Z",
    fill: "url(#paint219_linear_7547_125)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M681.041 375.753H679.33V457.602H681.041V375.753Z",
    fill: "url(#paint220_linear_7547_125)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M655.142 355.674H653.432V519.372H655.142V355.674Z",
    fill: "url(#paint221_linear_7547_125)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M629.24 371.426H627.529V536.865H629.24V371.426Z",
    fill: "url(#paint222_linear_7547_125)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M603.34 366.653H601.63V474.621H603.34V366.653Z",
    fill: "url(#paint223_linear_7547_125)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M585.149 412.723H568.018V445.442H585.149V412.723Z",
    fill: "url(#paint224_linear_7547_125)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1673.05 88.3392H1655.92V148.234H1673.05V88.3392Z",
    fill: "url(#paint225_linear_7547_125)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000268936 274.339H17.1318V334.234H0.000268936V274.339Z",
    fill: "url(#paint226_linear_7547_125)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.15 209.818H1630.02V226.969H1647.15V209.818Z",
    fill: "url(#paint227_linear_7547_125)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9036 335.818H43.0352V352.969H25.9036V335.818Z",
    fill: "url(#paint228_linear_7547_125)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.25 232.508H1604.12V248.602H1621.25V232.508Z",
    fill: "url(#paint229_linear_7547_125)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8029 358.508H68.9346V374.602H51.8029V358.508Z",
    fill: "url(#paint230_linear_7547_125)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1595.35 226.969H1578.21V255.202H1595.35V226.969Z",
    fill: "url(#paint231_linear_7547_125)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7063 352.969H94.8379V381.202H77.7063V352.969Z",
    fill: "url(#paint232_linear_7547_125)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1569.44 245.306H1552.31V269.712H1569.44V245.306Z",
    fill: "url(#paint233_linear_7547_125)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M103.609 371.306H120.74V395.712H103.609V371.306Z",
    fill: "url(#paint234_linear_7547_125)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.54 305.599H1526.41V337.791H1543.54V305.599Z",
    fill: "url(#paint235_linear_7547_125)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M129.506 431.599H146.638V463.791H129.506V431.599Z",
    fill: "url(#paint236_linear_7547_125)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M1517.64 307.709H1500.51V330.93H1517.64V307.709Z",
    fill: "url(#paint237_linear_7547_125)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M155.409 433.709H172.541V456.93H155.409V433.709Z",
    fill: "url(#paint238_linear_7547_125)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1491.74 263.116H1474.61V319.317H1491.74V263.116Z",
    fill: "url(#paint239_linear_7547_125)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M181.312 389.116H198.443V445.317H181.312V389.116Z",
    fill: "url(#paint240_linear_7547_125)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.84 237.653H1448.71V277.627H1465.84V237.653Z",
    fill: "url(#paint241_linear_7547_125)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M207.211 223.653H224.343V263.627H207.211V223.653Z",
    fill: "url(#paint242_linear_7547_125)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.94 229.999H1422.8V245.306H1439.94V229.999Z",
    fill: "url(#paint243_linear_7547_125)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M233.115 285.999H250.246V301.306H233.115V285.999Z",
    fill: "url(#paint244_linear_7547_125)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1414.03 219.316H1396.9V240.687H1414.03V219.316Z",
    fill: "url(#paint245_linear_7547_125)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M259.018 345.316H276.149V366.687H259.018V345.316Z",
    fill: "url(#paint246_linear_7547_125)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1388.13 219.316H1371V249.261H1388.13V219.316Z",
    fill: "url(#paint247_linear_7547_125)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M284.916 345.316H302.048V375.261H284.916V345.316Z",
    fill: "url(#paint248_linear_7547_125)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M310.82 382.781H327.951V401.778H310.82V382.781Z",
    fill: "url(#paint249_linear_7547_125)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M336.723 368.537H353.854V401.782H336.723V368.537Z",
    fill: "url(#paint250_linear_7547_125)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M362.621 375.265H379.753V385.161H362.621V375.265Z",
    fill: "url(#paint251_linear_7547_125)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M388.525 357.652H405.656V371.306H388.525V357.652Z",
    fill: "url(#paint252_linear_7547_125)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M414.428 343.997H431.56V371.306H414.428V343.997Z",
    fill: "url(#paint253_linear_7547_125)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M440.326 328.956H457.458V354.287H440.326V328.956Z",
    fill: "url(#paint254_linear_7547_125)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M466.23 339.246H483.361V368.532H466.23V339.246Z",
    fill: "url(#paint255_linear_7547_125)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M492.129 237.875H509.261V274.287H492.129V237.875Z",
    fill: "url(#paint256_linear_7547_125)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M518.051 302.916H535.183V333.092H518.051V302.916Z",
    fill: "url(#paint257_linear_7547_125)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M543.954 368.537H561.086V385.157H543.954V368.537Z",
    fill: "url(#paint258_linear_7547_125)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M2288.88 271.004H2287.17V347.63H2288.88V271.004Z",
    fill: "url(#paint259_linear_7547_125)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M2262.98 188.483H2261.27V373.946H2262.98V188.483Z",
    fill: "url(#paint260_linear_7547_125)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M2237.08 141.682H2235.37V273.598H2237.08V141.682Z",
    fill: "url(#paint261_linear_7547_125)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M2211.17 162.403H2209.46V212.907H2211.17V162.403Z",
    fill: "url(#paint262_linear_7547_125)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M2185.27 144.738H2183.56V215.265H2185.27V144.738Z",
    fill: "url(#paint263_linear_7547_125)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M2159.37 134.876H2157.66V233.705H2159.37V134.876Z",
    fill: "url(#paint264_linear_7547_125)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M2133.47 184.935H2131.76V247.624H2133.47V184.935Z",
    fill: "url(#paint265_linear_7547_125)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M2107.57 154.3H2105.86V264.01H2107.57V154.3Z",
    fill: "url(#paint266_linear_7547_125)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M2081.66 187.884H2079.95V220.534H2081.66V187.884Z",
    fill: "url(#paint267_linear_7547_125)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M2055.76 165.947H2054.05V211.006H2055.76V165.947Z",
    fill: "url(#paint268_linear_7547_125)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M2029.91 136.593H2028.2V226.711H2029.91V136.593Z",
    fill: "url(#paint269_linear_7547_125)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M2004.01 123.829H2002.3V207.419H2004.01V123.829Z",
    fill: "url(#paint270_linear_7547_125)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M1978.11 129.569H1976.4V226.219H1978.11V129.569Z",
    fill: "url(#paint271_linear_7547_125)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1952.21 0H1950.5V120.162H1952.21V0Z",
    fill: "url(#paint272_linear_7547_125)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1926.31 62.2107H1924.59V161.801H1926.31V62.2107Z",
    fill: "url(#paint273_linear_7547_125)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1900.41 173.421H1898.7V228.277H1900.41V173.421Z",
    fill: "url(#paint274_linear_7547_125)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1874.5 146.93H1872.79V227.254H1874.5V146.93Z",
    fill: "url(#paint275_linear_7547_125)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1848.6 133.879H1846.89V274.937H1848.6V133.879Z",
    fill: "url(#paint276_linear_7547_125)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.7 128.182H1820.99V342.378H1822.7V128.182Z",
    fill: "url(#paint277_linear_7547_125)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M1796.8 157.112H1795.09V457.511H1796.8V157.112Z",
    fill: "url(#paint278_linear_7547_125)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M1770.9 287.997H1769.18V408.154H1770.9V287.997Z",
    fill: "url(#paint279_linear_7547_125)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1745 256.968H1743.29V398.027H1745V256.968Z",
    fill: "url(#paint280_linear_7547_125)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.09 182.964H1717.38V312.265H1719.09V182.964Z",
    fill: "url(#paint281_linear_7547_125)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.19 85.5968H1691.48V226.655H1693.19V85.5968Z",
    fill: "url(#paint282_linear_7547_125)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M2296.59 297.709H2279.46V320.93H2296.59V297.709Z",
    fill: "url(#paint283_linear_7547_125)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M2270.69 253.116H2253.56V309.317H2270.69V253.116Z",
    fill: "url(#paint284_linear_7547_125)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M2244.79 187.653H2227.66V227.627H2244.79V187.653Z",
    fill: "url(#paint285_linear_7547_125)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M2218.88 179.999H2201.75V195.306H2218.88V179.999Z",
    fill: "url(#paint286_linear_7547_125)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M2192.98 169.316H2175.85V190.688H2192.98V169.316Z",
    fill: "url(#paint287_linear_7547_125)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M2167.08 169.316H2149.95V199.261H2167.08V169.316Z",
    fill: "url(#paint288_linear_7547_125)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M2141.18 206.781H2124.05V225.778H2141.18V206.781Z",
    fill: "url(#paint289_linear_7547_125)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M2115.28 192.536H2098.14V225.782H2115.28V192.536Z",
    fill: "url(#paint290_linear_7547_125)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M2089.38 199.265H2072.25V209.161H2089.38V199.265Z",
    fill: "url(#paint291_linear_7547_125)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M2063.53 181.652H2046.39V195.306H2063.53V181.652Z",
    fill: "url(#paint292_linear_7547_125)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M2037.62 167.997H2020.49V195.306H2037.62V167.997Z",
    fill: "url(#paint293_linear_7547_125)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M2011.72 152.956H1994.59V178.287H2011.72V152.956Z",
    fill: "url(#paint294_linear_7547_125)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M1985.82 163.246H1968.69V192.532H1985.82V163.246Z",
    fill: "url(#paint295_linear_7547_125)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1959.92 41.8745H1942.79V78.2873H1959.92V41.8745Z",
    fill: "url(#paint296_linear_7547_125)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1934.02 96.9156H1916.89V127.092H1934.02V96.9156Z",
    fill: "url(#paint297_linear_7547_125)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.11 192.536H1890.98V209.157H1908.11V192.536Z",
    fill: "url(#paint298_linear_7547_125)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1882.22 174.923H1865.08V199.265H1882.22V174.923Z",
    fill: "url(#paint299_linear_7547_125)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1856.31 183.034H1839.18V225.778H1856.31V183.034Z",
    fill: "url(#paint300_linear_7547_125)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1830.41 202.827H1813.28V267.734H1830.41V202.827Z",
    fill: "url(#paint301_linear_7547_125)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1804.51 261.797H1787.38V352.826H1804.51V261.797Z",
    fill: "url(#paint302_linear_7547_125)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1778.61 329.871H1761.48V366.284H1778.61V329.871Z",
    fill: "url(#paint303_linear_7547_125)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1752.7 306.124H1735.57V348.867H1752.7V306.124Z",
    fill: "url(#paint304_linear_7547_125)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.81 228.023H1709.67V267.206H1726.81V228.023Z",
    fill: "url(#paint305_linear_7547_125)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.9 134.752H1683.77V177.495H1700.9V134.752Z",
    fill: "url(#paint306_linear_7547_125)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M856.547 204.3H858.258V314.01H856.547V204.3Z",
    fill: "url(#paint307_linear_7547_125)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M882.45 237.884H884.16V270.534H882.45V237.884Z",
    fill: "url(#paint308_linear_7547_125)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M908.353 215.947H910.063V261.006H908.353V215.947Z",
    fill: "url(#paint309_linear_7547_125)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M934.252 186.593H935.963V276.711H934.252V186.593Z",
    fill: "url(#paint310_linear_7547_125)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M960.155 173.829H961.865V257.419H960.155V173.829Z",
    fill: "url(#paint311_linear_7547_125)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M986.053 179.569H987.764V276.219H986.053V179.569Z",
    fill: "url(#paint312_linear_7547_125)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.96 150H1013.67V270.162H1011.96V150Z",
    fill: "url(#paint313_linear_7547_125)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.9 172.211H1039.61V271.801H1037.9V172.211Z",
    fill: "url(#paint314_linear_7547_125)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.8 223.421H1065.51V278.277H1063.8V223.421Z",
    fill: "url(#paint315_linear_7547_125)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.71 196.93H1091.42V277.254H1089.71V196.93Z",
    fill: "url(#paint316_linear_7547_125)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.61 183.879H1117.32V324.937H1115.61V183.879Z",
    fill: "url(#paint317_linear_7547_125)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.51 178.182H1143.22V392.378H1141.51V178.182Z",
    fill: "url(#paint318_linear_7547_125)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.4 207.113H1169.11V507.511H1167.4V207.113Z",
    fill: "url(#paint319_linear_7547_125)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.3 337.997H1195.01V458.154H1193.3V337.997Z",
    fill: "url(#paint320_linear_7547_125)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.2 306.968H1220.91V448.027H1219.2V306.968Z",
    fill: "url(#paint321_linear_7547_125)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.11 282.964H1246.82V412.265H1245.11V282.964Z",
    fill: "url(#paint322_linear_7547_125)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M1271.01 285.597H1272.72V426.655H1271.01V285.597Z",
    fill: "url(#paint323_linear_7547_125)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.91 282.733H1298.62V344.554H1296.91V282.733Z",
    fill: "url(#paint324_linear_7547_125)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.81 265.826H1324.52V397.742H1322.81V265.826Z",
    fill: "url(#paint325_linear_7547_125)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M822.935 256.781H840.066V275.778H822.935V256.781Z",
    fill: "url(#paint326_linear_7547_125)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M848.839 242.537H865.971V275.782H848.839V242.537Z",
    fill: "url(#paint327_linear_7547_125)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M874.738 249.265H891.869V259.161H874.738V249.265Z",
    fill: "url(#paint328_linear_7547_125)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M900.64 231.652H917.771V245.306H900.64V231.652Z",
    fill: "url(#paint329_linear_7547_125)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M926.544 217.997H943.676V245.306H926.544V217.997Z",
    fill: "url(#paint330_linear_7547_125)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M952.443 202.956H969.574V228.287H952.443V202.956Z",
    fill: "url(#paint331_linear_7547_125)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M978.345 213.246H995.477V242.532H978.345V213.246Z",
    fill: "url(#paint332_linear_7547_125)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.25 191.875H1021.38V228.287H1004.25V191.875Z",
    fill: "url(#paint333_linear_7547_125)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 206.916H1047.32V237.092H1030.19V206.916Z",
    fill: "url(#paint334_linear_7547_125)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.09 242.537H1073.23V259.157H1056.09V242.537Z",
    fill: "url(#paint335_linear_7547_125)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.99 224.923H1099.12V249.265H1081.99V224.923Z",
    fill: "url(#paint336_linear_7547_125)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.9 233.034H1125.03V275.778H1107.9V233.034Z",
    fill: "url(#paint337_linear_7547_125)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.8 252.826H1150.93V317.733H1133.8V252.826Z",
    fill: "url(#paint338_linear_7547_125)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.69 311.797H1176.82V402.826H1159.69V311.797Z",
    fill: "url(#paint339_linear_7547_125)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.59 379.871H1202.72V416.284H1185.59V379.871Z",
    fill: "url(#paint340_linear_7547_125)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.49 356.124H1228.63V398.867H1211.49V356.124Z",
    fill: "url(#paint341_linear_7547_125)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.39 328.023H1254.52V367.206H1237.39V328.023Z",
    fill: "url(#paint342_linear_7547_125)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.3 334.752H1280.43V377.495H1263.3V334.752Z",
    fill: "url(#paint343_linear_7547_125)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.2 304.276H1306.33V323.011H1289.2V304.276Z",
    fill: "url(#paint344_linear_7547_125)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.1 311.797H1332.23V351.771H1315.1V311.797Z",
    fill: "url(#paint345_linear_7547_125)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M844.165 353.354H827.033V371.165H844.165V353.354Z",
    fill: "url(#paint346_linear_7547_125)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M818.26 362.853H801.129V396.89H818.26V362.853Z",
    fill: "url(#paint347_linear_7547_125)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M792.362 373.541H775.23V424.198H792.362V373.541Z",
    fill: "url(#paint348_linear_7547_125)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M766.459 412.723H749.327V445.442H766.459V412.723Z",
    fill: "url(#paint349_linear_7547_125)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M740.555 433.302H723.424V445.442H740.555V433.302Z",
    fill: "url(#paint350_linear_7547_125)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M714.657 396.89H697.525V469.715H714.657V396.89Z",
    fill: "url(#paint351_linear_7547_125)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M688.754 404.278H671.622V429.078H688.754V404.278Z",
    fill: "url(#paint352_linear_7547_125)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M662.85 412.723H645.719V462.327H662.85V412.723Z",
    fill: "url(#paint353_linear_7547_125)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M636.952 429.082H619.82V479.213H636.952V429.082Z",
    fill: "url(#paint354_linear_7547_125)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M611.053 404.278H593.922V436.996H611.053V404.278Z",
    fill: "url(#paint355_linear_7547_125)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M5180.46 178.366H5178.75V70.3987H5180.46V178.366Z",
    fill: "url(#paint356_linear_7547_125)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M6268.3 534H6266.59V336.347H6268.3V534Z",
    fill: "url(#paint357_linear_7547_125)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M4610.71 348H4612.42V150.347H4610.71V348Z",
    fill: "url(#paint358_linear_7547_125)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M6242.4 363.366H6240.69V306.767H6242.4V363.366Z",
    fill: "url(#paint359_linear_7547_125)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M4636.61 237.366H4638.32V180.767H4636.61V237.366Z",
    fill: "url(#paint360_linear_7547_125)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M6216.5 339.461H6214.79V286.346H6216.5V339.461Z",
    fill: "url(#paint361_linear_7547_125)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M4662.51 213.46H4664.23V160.346H4662.51V213.46Z",
    fill: "url(#paint362_linear_7547_125)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M6190.6 358.957H6188.88V265.792H6190.6V358.957Z",
    fill: "url(#paint363_linear_7547_125)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M4688.42 232.957H4690.13V139.792H4688.42V232.957Z",
    fill: "url(#paint364_linear_7547_125)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M6164.7 336.22H6162.99V255.677H6164.7V336.22Z",
    fill: "url(#paint365_linear_7547_125)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M4714.32 210.22H4716.03V129.677H4714.32V210.22Z",
    fill: "url(#paint366_linear_7547_125)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M6138.79 284.882H6137.08V178.653H6138.79V284.882Z",
    fill: "url(#paint367_linear_7547_125)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M4740.22 158.882H4741.93V52.6526H4740.22V158.882Z",
    fill: "url(#paint368_linear_7547_125)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M6112.89 272.456H6111.18V195.83H6112.89V272.456Z",
    fill: "url(#paint369_linear_7547_125)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M4766.12 146.456H4767.83V69.8296H4766.12V146.456Z",
    fill: "url(#paint370_linear_7547_125)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M6086.99 354.977H6085.28V169.514H6086.99V354.977Z",
    fill: "url(#paint371_linear_7547_125)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M4792.02 228.977H4793.73V43.5141H4792.02V228.977Z",
    fill: "url(#paint372_linear_7547_125)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M6061.09 361.778H6059.38V229.863H6061.09V361.778Z",
    fill: "url(#paint373_linear_7547_125)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M4817.92 375.778H4819.64V243.863H4817.92V375.778Z",
    fill: "url(#paint374_linear_7547_125)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M6035.19 341.057H6033.47V290.553H6035.19V341.057Z",
    fill: "url(#paint375_linear_7547_125)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M4843.83 285.057H4845.54V234.553H4843.83V285.057Z",
    fill: "url(#paint376_linear_7547_125)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M6009.29 358.722H6007.58V288.195H6009.29V358.722Z",
    fill: "url(#paint377_linear_7547_125)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M4869.73 232.722H4871.44V162.195H4869.73V232.722Z",
    fill: "url(#paint378_linear_7547_125)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M5983.38 368.584H5981.67V269.755H5983.38V368.584Z",
    fill: "url(#paint379_linear_7547_125)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M4895.63 242.584H4897.34V143.755H4895.63V242.584Z",
    fill: "url(#paint380_linear_7547_125)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M5957.48 318.525H5955.77V255.836H5957.48V318.525Z",
    fill: "url(#paint381_linear_7547_125)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M4921.53 192.525H4923.24V129.836H4921.53V192.525Z",
    fill: "url(#paint382_linear_7547_125)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M4947.43 223.16H4949.14V113.45H4947.43V223.16Z",
    fill: "url(#paint383_linear_7547_125)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M4973.33 189.576H4975.05V156.926H4973.33V189.576Z",
    fill: "url(#paint384_linear_7547_125)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M4999.24 211.513H5000.95V166.454H4999.24V211.513Z",
    fill: "url(#paint385_linear_7547_125)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M5025.14 240.868H5026.85V150.749H5025.14V240.868Z",
    fill: "url(#paint386_linear_7547_125)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M5051.04 253.631H5052.75V170.041H5051.04V253.631Z",
    fill: "url(#paint387_linear_7547_125)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M5076.94 247.891H5078.65V151.242H5076.94V247.891Z",
    fill: "url(#paint388_linear_7547_125)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M5102.84 327.46H5104.55V207.298H5102.84V327.46Z",
    fill: "url(#paint389_linear_7547_125)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M5128.79 285.249H5130.5V185.659H5128.79V285.249Z",
    fill: "url(#paint390_linear_7547_125)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M5154.69 204.04H5156.4V149.183H5154.69V204.04Z",
    fill: "url(#paint391_linear_7547_125)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M5439.48 220.587H5437.77V161.814H5439.48V220.587Z",
    fill: "url(#paint392_linear_7547_125)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M5413.58 229.751H5411.87V117.427H5413.58V229.751Z",
    fill: "url(#paint393_linear_7547_125)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M5387.68 238.179H5385.97V71.0022H5387.68V238.179Z",
    fill: "url(#paint394_linear_7547_125)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M5361.77 178.366H5360.06V70.3987H5361.77V178.366Z",
    fill: "url(#paint395_linear_7547_125)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M5335.87 134.116H5334.16V94.0603H5335.87V134.116Z",
    fill: "url(#paint396_linear_7547_125)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M5309.97 240.319H5308.26V0H5309.97V240.319Z",
    fill: "url(#paint397_linear_7547_125)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M5284.07 177.707H5282.36V95.8581H5284.07V177.707Z",
    fill: "url(#paint398_linear_7547_125)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M5258.17 197.786H5256.46V34.0885H5258.17V197.786Z",
    fill: "url(#paint399_linear_7547_125)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M5232.27 182.034H5230.56V16.5948H5232.27V182.034Z",
    fill: "url(#paint400_linear_7547_125)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M5206.37 186.807H5204.66V78.8395H5206.37V186.807Z",
    fill: "url(#paint401_linear_7547_125)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M5188.18 140.737H5171.05V108.019H5188.18V140.737Z",
    fill: "url(#paint402_linear_7547_125)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M6276.01 465.121H6258.88V405.226H6276.01V465.121Z",
    fill: "url(#paint403_linear_7547_125)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M4603 279.121H4620.13V219.226H4603V279.121Z",
    fill: "url(#paint404_linear_7547_125)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M6250.11 343.642H6232.98V326.491H6250.11V343.642Z",
    fill: "url(#paint405_linear_7547_125)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M4628.9 217.642H4646.03V200.491H4628.9V217.642Z",
    fill: "url(#paint406_linear_7547_125)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M6224.21 320.952H6207.08V304.858H6224.21V320.952Z",
    fill: "url(#paint407_linear_7547_125)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M4654.8 194.952H4671.93V178.858H4654.8V194.952Z",
    fill: "url(#paint408_linear_7547_125)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M6198.31 326.491H6181.18V298.258H6198.31V326.491Z",
    fill: "url(#paint409_linear_7547_125)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M4680.71 200.491H4697.84V172.258H4680.71V200.491Z",
    fill: "url(#paint410_linear_7547_125)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M6172.41 308.154H6155.27V283.748H6172.41V308.154Z",
    fill: "url(#paint411_linear_7547_125)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M4706.61 182.154H4723.74V157.748H4706.61V182.154Z",
    fill: "url(#paint412_linear_7547_125)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M6146.51 247.861H6129.38V215.669H6146.51V247.861Z",
    fill: "url(#paint413_linear_7547_125)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M4732.51 121.861H4749.64V89.6689H4732.51V121.861Z",
    fill: "url(#paint414_linear_7547_125)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M6120.6 245.751H6103.47V222.53H6120.6V245.751Z",
    fill: "url(#paint415_linear_7547_125)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M4758.41 119.751H4775.54V96.5303H4758.41V119.751Z",
    fill: "url(#paint416_linear_7547_125)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M6094.7 290.344H6077.57V234.143H6094.7V290.344Z",
    fill: "url(#paint417_linear_7547_125)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M4784.31 164.344H4801.44V108.143H4784.31V164.344Z",
    fill: "url(#paint418_linear_7547_125)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M6068.8 315.807H6051.67V275.833H6068.8V315.807Z",
    fill: "url(#paint419_linear_7547_125)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M4810.21 329.807H4827.34V289.833H4810.21V329.807Z",
    fill: "url(#paint420_linear_7547_125)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M6042.9 323.461H6025.77V308.154H6042.9V323.461Z",
    fill: "url(#paint421_linear_7547_125)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M4836.12 267.461H4853.25V252.154H4836.12V267.461Z",
    fill: "url(#paint422_linear_7547_125)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M6016.99 334.144H5999.86V312.773H6016.99V334.144Z",
    fill: "url(#paint423_linear_7547_125)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M4862.02 208.144H4879.15V186.773H4862.02V208.144Z",
    fill: "url(#paint424_linear_7547_125)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M5991.1 334.144H5973.96V304.199H5991.1V334.144Z",
    fill: "url(#paint425_linear_7547_125)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M4887.92 208.144H4905.05V178.199H4887.92V208.144Z",
    fill: "url(#paint426_linear_7547_125)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M4913.82 170.679H4930.95V151.682H4913.82V170.679Z",
    fill: "url(#paint427_linear_7547_125)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M4939.72 184.924H4956.85V151.678H4939.72V184.924Z",
    fill: "url(#paint428_linear_7547_125)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M4965.62 178.195H4982.75V168.299H4965.62V178.195Z",
    fill: "url(#paint429_linear_7547_125)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M4991.53 195.808H5008.66V182.154H4991.53V195.808Z",
    fill: "url(#paint430_linear_7547_125)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M5017.43 209.463H5034.56V182.154H5017.43V209.463Z",
    fill: "url(#paint431_linear_7547_125)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M5043.33 224.504H5060.46V199.173H5043.33V224.504Z",
    fill: "url(#paint432_linear_7547_125)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M5069.23 214.214H5086.36V184.928H5069.23V214.214Z",
    fill: "url(#paint433_linear_7547_125)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M5095.13 285.586H5112.26V249.173H5095.13V285.586Z",
    fill: "url(#paint434_linear_7547_125)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M5121.08 250.544H5138.21V220.368H5121.08V250.544Z",
    fill: "url(#paint435_linear_7547_125)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M5146.98 184.924H5164.11V168.303H5146.98V184.924Z",
    fill: "url(#paint436_linear_7547_125)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M6891.88 282.456H6890.17V205.83H6891.88V282.456Z",
    fill: "url(#paint437_linear_7547_125)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M6865.98 364.977H6864.27V179.514H6865.98V364.977Z",
    fill: "url(#paint438_linear_7547_125)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M6840.08 411.778H6838.37V279.863H6840.08V411.778Z",
    fill: "url(#paint439_linear_7547_125)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M6814.17 391.057H6812.46V340.553H6814.17V391.057Z",
    fill: "url(#paint440_linear_7547_125)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M6788.27 408.722H6786.56V338.195H6788.27V408.722Z",
    fill: "url(#paint441_linear_7547_125)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M6762.37 418.584H6760.66V319.755H6762.37V418.584Z",
    fill: "url(#paint442_linear_7547_125)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M6736.47 368.525H6734.76V305.836H6736.47V368.525Z",
    fill: "url(#paint443_linear_7547_125)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M6710.57 399.16H6708.86V289.45H6710.57V399.16Z",
    fill: "url(#paint444_linear_7547_125)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M6684.66 365.576H6682.95V332.926H6684.66V365.576Z",
    fill: "url(#paint445_linear_7547_125)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M6658.76 387.513H6657.05V342.454H6658.76V387.513Z",
    fill: "url(#paint446_linear_7547_125)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M6632.88 416.868H6631.17V326.749H6632.88V416.868Z",
    fill: "url(#paint447_linear_7547_125)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M6606.97 429.631H6605.26V346.041H6606.97V429.631Z",
    fill: "url(#paint448_linear_7547_125)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M6581.07 423.891H6579.36V327.242H6581.07V423.891Z",
    fill: "url(#paint449_linear_7547_125)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M6555.17 553.46H6553.46V433.298H6555.17V553.46Z",
    fill: "url(#paint450_linear_7547_125)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M6529.27 491.249H6527.56V391.659H6529.27V491.249Z",
    fill: "url(#paint451_linear_7547_125)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M6503.37 380.04H6501.66V325.183H6503.37V380.04Z",
    fill: "url(#paint452_linear_7547_125)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M6477.47 406.531H6475.76V326.206H6477.47V406.531Z",
    fill: "url(#paint453_linear_7547_125)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M6899.59 255.751H6882.46V232.53H6899.59V255.751Z",
    fill: "url(#paint454_linear_7547_125)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M6873.69 300.344H6856.56V244.143H6873.69V300.344Z",
    fill: "url(#paint455_linear_7547_125)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M6847.79 365.807H6830.66V325.833H6847.79V365.807Z",
    fill: "url(#paint456_linear_7547_125)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M6821.88 373.461H6804.75V358.154H6821.88V373.461Z",
    fill: "url(#paint457_linear_7547_125)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M6795.98 384.144H6778.85V362.773H6795.98V384.144Z",
    fill: "url(#paint458_linear_7547_125)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M6770.08 384.144H6752.95V354.199H6770.08V384.144Z",
    fill: "url(#paint459_linear_7547_125)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M6744.18 346.679H6727.05V327.682H6744.18V346.679Z",
    fill: "url(#paint460_linear_7547_125)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M6718.28 360.924H6701.14V327.678H6718.28V360.924Z",
    fill: "url(#paint461_linear_7547_125)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M6692.38 354.195H6675.25V344.299H6692.38V354.195Z",
    fill: "url(#paint462_linear_7547_125)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M6666.49 371.808H6649.36V358.154H6666.49V371.808Z",
    fill: "url(#paint463_linear_7547_125)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M6640.58 385.463H6623.45V358.154H6640.58V385.463Z",
    fill: "url(#paint464_linear_7547_125)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M6614.69 400.504H6597.55V375.173H6614.69V400.504Z",
    fill: "url(#paint465_linear_7547_125)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M6588.78 390.214H6571.65V360.928H6588.78V390.214Z",
    fill: "url(#paint466_linear_7547_125)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M6562.88 511.586H6545.75V475.173H6562.88V511.586Z",
    fill: "url(#paint467_linear_7547_125)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M6536.98 456.544H6519.85V426.368H6536.98V456.544Z",
    fill: "url(#paint468_linear_7547_125)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M6511.08 360.924H6493.95V344.303H6511.08V360.924Z",
    fill: "url(#paint469_linear_7547_125)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M6485.18 378.537H6468.05V354.195H6485.18V378.537Z",
    fill: "url(#paint470_linear_7547_125)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M6294.44 419.581H6296.16V278.523H6294.44V419.581Z",
    fill: "url(#paint471_linear_7547_125)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M6320.34 425.278H6322.05V211.082H6320.34V425.278Z",
    fill: "url(#paint472_linear_7547_125)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M6346.25 396.348H6347.96V95.9495H6346.25V396.348Z",
    fill: "url(#paint473_linear_7547_125)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M6372.15 265.464H6373.86V145.306H6372.15V265.464Z",
    fill: "url(#paint474_linear_7547_125)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M6398.05 296.492H6399.76V155.433H6398.05V296.492Z",
    fill: "url(#paint475_linear_7547_125)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M6423.95 370.496H6425.66V241.195H6423.95V370.496Z",
    fill: "url(#paint476_linear_7547_125)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M6449.85 467.863H6451.57V326.805H6449.85V467.863Z",
    fill: "url(#paint477_linear_7547_125)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M6286.73 370.426H6303.86V327.682H6286.73V370.426Z",
    fill: "url(#paint478_linear_7547_125)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M6312.64 350.634H6329.77V285.727H6312.64V350.634Z",
    fill: "url(#paint479_linear_7547_125)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M6338.53 291.663H6355.67V200.634H6338.53V291.663Z",
    fill: "url(#paint480_linear_7547_125)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M6364.44 223.589H6381.57V187.176H6364.44V223.589Z",
    fill: "url(#paint481_linear_7547_125)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M6390.34 247.336H6407.47V204.593H6390.34V247.336Z",
    fill: "url(#paint482_linear_7547_125)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M6416.24 325.437H6433.37V286.254H6416.24V325.437Z",
    fill: "url(#paint483_linear_7547_125)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M6442.14 418.708H6459.27V375.965H6442.14V418.708Z",
    fill: "url(#paint484_linear_7547_125)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M5459.57 349.16H5461.28V239.45H5459.57V349.16Z",
    fill: "url(#paint485_linear_7547_125)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M5485.48 315.576H5487.19V282.926H5485.48V315.576Z",
    fill: "url(#paint486_linear_7547_125)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M5511.38 337.513H5513.09V292.454H5511.38V337.513Z",
    fill: "url(#paint487_linear_7547_125)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M5537.28 366.868H5538.99V276.749H5537.28V366.868Z",
    fill: "url(#paint488_linear_7547_125)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M5563.18 379.631H5564.89V296.041H5563.18V379.631Z",
    fill: "url(#paint489_linear_7547_125)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M5589.08 373.891H5590.79V277.242H5589.08V373.891Z",
    fill: "url(#paint490_linear_7547_125)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M5614.98 403.46H5616.69V283.298H5614.98V403.46Z",
    fill: "url(#paint491_linear_7547_125)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M5640.87 381.249H5642.58V281.659H5640.87V381.249Z",
    fill: "url(#paint492_linear_7547_125)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M5666.77 330.039H5668.48V275.183H5666.77V330.039Z",
    fill: "url(#paint493_linear_7547_125)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M5692.67 356.531H5694.38V276.206H5692.67V356.531Z",
    fill: "url(#paint494_linear_7547_125)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M5718.57 369.581H5720.28V228.523H5718.57V369.581Z",
    fill: "url(#paint495_linear_7547_125)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M5744.47 375.278H5746.18V161.082H5744.47V375.278Z",
    fill: "url(#paint496_linear_7547_125)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M5770.36 346.348H5772.07V45.9494H5770.36V346.348Z",
    fill: "url(#paint497_linear_7547_125)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M5796.27 215.464H5797.98V95.306H5796.27V215.464Z",
    fill: "url(#paint498_linear_7547_125)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M5822.16 246.492H5823.88V105.433H5822.16V246.492Z",
    fill: "url(#paint499_linear_7547_125)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M5848.07 270.496H5849.78V141.195H5848.07V270.496Z",
    fill: "url(#paint500_linear_7547_125)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M5873.97 267.863H5875.68V126.805H5873.97V267.863Z",
    fill: "url(#paint501_linear_7547_125)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M5899.87 270.727H5901.58V208.906H5899.87V270.727Z",
    fill: "url(#paint502_linear_7547_125)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M5925.77 287.634H5927.48V155.719H5925.77V287.634Z",
    fill: "url(#paint503_linear_7547_125)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M5451.87 310.924H5469V277.678H5451.87V310.924Z",
    fill: "url(#paint504_linear_7547_125)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M5477.76 304.195H5494.9V294.299H5477.76V304.195Z",
    fill: "url(#paint505_linear_7547_125)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M5503.67 321.808H5520.8V308.154H5503.67V321.808Z",
    fill: "url(#paint506_linear_7547_125)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M5529.57 335.463H5546.7V308.154H5529.57V335.463Z",
    fill: "url(#paint507_linear_7547_125)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M5555.47 350.504H5572.6V325.173H5555.47V350.504Z",
    fill: "url(#paint508_linear_7547_125)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M5581.37 340.214H5598.5V310.928H5581.37V340.214Z",
    fill: "url(#paint509_linear_7547_125)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M5607.27 361.586H5624.4V325.173H5607.27V361.586Z",
    fill: "url(#paint510_linear_7547_125)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M5633.15 346.544H5650.29V316.368H5633.15V346.544Z",
    fill: "url(#paint511_linear_7547_125)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M5659.06 310.924H5676.19V294.303H5659.06V310.924Z",
    fill: "url(#paint512_linear_7547_125)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M5684.96 328.537H5702.09V304.195H5684.96V328.537Z",
    fill: "url(#paint513_linear_7547_125)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M5710.86 320.426H5727.99V277.682H5710.86V320.426Z",
    fill: "url(#paint514_linear_7547_125)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M5736.76 300.634H5753.89V235.727H5736.76V300.634Z",
    fill: "url(#paint515_linear_7547_125)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M5762.65 241.663H5779.78V150.634H5762.65V241.663Z",
    fill: "url(#paint516_linear_7547_125)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M5788.55 173.589H5805.69V137.176H5788.55V173.589Z",
    fill: "url(#paint517_linear_7547_125)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M5814.46 197.336H5831.59V154.593H5814.46V197.336Z",
    fill: "url(#paint518_linear_7547_125)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M5840.35 225.437H5857.49V186.254H5840.35V225.437Z",
    fill: "url(#paint519_linear_7547_125)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M5866.26 218.708H5883.39V175.965H5866.26V218.708Z",
    fill: "url(#paint520_linear_7547_125)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M5892.16 249.184H5909.29V230.449H5892.16V249.184Z",
    fill: "url(#paint521_linear_7547_125)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M5918.06 241.663H5935.19V201.689H5918.06V241.663Z",
    fill: "url(#paint522_linear_7547_125)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M5447.19 200.106H5430.06V182.295H5447.19V200.106Z",
    fill: "url(#paint523_linear_7547_125)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M5421.29 190.608H5404.16V156.57H5421.29V190.608Z",
    fill: "url(#paint524_linear_7547_125)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M5395.39 179.92H5378.26V129.262H5395.39V179.92Z",
    fill: "url(#paint525_linear_7547_125)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M5369.49 140.737H5352.35V108.019H5369.49V140.737Z",
    fill: "url(#paint526_linear_7547_125)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M5343.58 120.158H5326.45V108.019H5343.58V120.158Z",
    fill: "url(#paint527_linear_7547_125)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M5317.68 156.57H5300.55V83.7447H5317.68V156.57Z",
    fill: "url(#paint528_linear_7547_125)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M5291.78 149.182H5274.65V124.382H5291.78V149.182Z",
    fill: "url(#paint529_linear_7547_125)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M5265.88 140.737H5248.75V91.1326H5265.88V140.737Z",
    fill: "url(#paint530_linear_7547_125)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M5239.98 124.378H5222.85V74.2467H5239.98V124.378Z",
    fill: "url(#paint531_linear_7547_125)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M5214.08 149.182H5196.95V116.464H5214.08V149.182Z",
    fill: "url(#paint532_linear_7547_125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7547_125",
    x1: 2877.59,
    y1: 482.606,
    x2: 2877.59,
    y2: 374.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7547_125",
    x1: 3965.49,
    y1: 276.653,
    x2: 3965.49,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7547_125",
    x1: 2309.57,
    y1: 402.653,
    x2: 2309.57,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7547_125",
    x1: 3939.59,
    y1: 246.233,
    x2: 3939.59,
    y2: 189.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7547_125",
    x1: 2335.47,
    y1: 372.233,
    x2: 2335.47,
    y2: 315.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7547_125",
    x1: 3913.69,
    y1: 266.654,
    x2: 3913.69,
    y2: 213.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7547_125",
    x1: 2361.37,
    y1: 392.654,
    x2: 2361.37,
    y2: 339.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7547_125",
    x1: 3887.78,
    y1: 287.208,
    x2: 3887.78,
    y2: 194.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7547_125",
    x1: 2387.27,
    y1: 413.208,
    x2: 2387.27,
    y2: 320.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7547_125",
    x1: 3861.88,
    y1: 297.319,
    x2: 3861.88,
    y2: 216.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7547_125",
    x1: 2413.17,
    y1: 423.318,
    x2: 2413.17,
    y2: 342.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7547_125",
    x1: 3835.98,
    y1: 374.347,
    x2: 3835.98,
    y2: 268.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7547_125",
    x1: 2439.07,
    y1: 500.347,
    x2: 2439.07,
    y2: 394.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7547_125",
    x1: 3810.08,
    y1: 357.17,
    x2: 3810.08,
    y2: 280.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7547_125",
    x1: 2464.97,
    y1: 483.17,
    x2: 2464.97,
    y2: 406.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7547_125",
    x1: 3784.17,
    y1: 383.49,
    x2: 3784.17,
    y2: 198.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7547_125",
    x1: 2490.88,
    y1: 509.49,
    x2: 2490.88,
    y2: 324.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7547_125",
    x1: 3758.28,
    y1: 323.137,
    x2: 3758.28,
    y2: 191.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7547_125",
    x1: 2516.78,
    y1: 449.137,
    x2: 2516.78,
    y2: 317.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7547_125",
    x1: 3732.37,
    y1: 262.447,
    x2: 3732.37,
    y2: 211.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7547_125",
    x1: 2542.68,
    y1: 388.447,
    x2: 2542.68,
    y2: 337.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7547_125",
    x1: 3706.47,
    y1: 264.805,
    x2: 3706.47,
    y2: 194.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7547_125",
    x1: 2568.58,
    y1: 390.805,
    x2: 2568.58,
    y2: 320.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7547_125",
    x1: 3680.57,
    y1: 283.245,
    x2: 3680.57,
    y2: 184.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7547_125",
    x1: 2594.48,
    y1: 409.245,
    x2: 2594.48,
    y2: 310.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7547_125",
    x1: 3654.67,
    y1: 297.169,
    x2: 3654.67,
    y2: 234.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7547_125",
    x1: 2620.38,
    y1: 423.169,
    x2: 2620.38,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7547_125",
    x1: 3628.76,
    y1: 313.554,
    x2: 3628.76,
    y2: 203.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7547_125",
    x1: 2646.29,
    y1: 439.554,
    x2: 2646.29,
    y2: 329.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7547_125",
    x1: 3602.87,
    y1: 270.078,
    x2: 3602.87,
    y2: 237.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7547_125",
    x1: 2672.19,
    y1: 396.078,
    x2: 2672.19,
    y2: 363.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7547_125",
    x1: 3576.96,
    y1: 260.546,
    x2: 3576.96,
    y2: 215.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7547_125",
    x1: 2698.09,
    y1: 386.546,
    x2: 2698.09,
    y2: 341.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7547_125",
    x1: 3551.06,
    y1: 276.251,
    x2: 3551.06,
    y2: 186.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7547_125",
    x1: 2723.99,
    y1: 402.251,
    x2: 2723.99,
    y2: 312.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7547_125",
    x1: 3525.16,
    y1: 256.955,
    x2: 3525.16,
    y2: 173.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7547_125",
    x1: 2749.89,
    y1: 382.955,
    x2: 2749.89,
    y2: 299.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_7547_125",
    x1: 3499.26,
    y1: 275.754,
    x2: 3499.26,
    y2: 179.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7547_125",
    x1: 2775.8,
    y1: 401.754,
    x2: 2775.8,
    y2: 305.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_7547_125",
    x1: 3473.36,
    y1: 269.702,
    x2: 3473.36,
    y2: 149.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7547_125",
    x1: 2801.69,
    y1: 395.702,
    x2: 2801.69,
    y2: 275.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_7547_125",
    x1: 3447.46,
    y1: 271.337,
    x2: 3447.46,
    y2: 171.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7547_125",
    x1: 2827.62,
    y1: 397.337,
    x2: 2827.62,
    y2: 297.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7547_125",
    x1: 3421.55,
    y1: 277.813,
    x2: 3421.55,
    y2: 222.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7547_125",
    x1: 2853.52,
    y1: 403.813,
    x2: 2853.52,
    y2: 348.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7547_125",
    x1: 3395.65,
    y1: 276.794,
    x2: 3395.65,
    y2: 196.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7547_125",
    x1: 3369.75,
    y1: 324.477,
    x2: 3369.75,
    y2: 183.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_7547_125",
    x1: 3343.85,
    y1: 391.918,
    x2: 3343.85,
    y2: 177.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7547_125",
    x1: 3317.92,
    y1: 507.051,
    x2: 3317.92,
    y2: 206.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_7547_125",
    x1: 3292.01,
    y1: 457.698,
    x2: 3292.01,
    y2: 337.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7547_125",
    x1: 3266.11,
    y1: 447.567,
    x2: 3266.11,
    y2: 306.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_7547_125",
    x1: 3240.21,
    y1: 411.805,
    x2: 3240.21,
    y2: 282.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7547_125",
    x1: 3214.31,
    y1: 426.195,
    x2: 3214.31,
    y2: 285.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_7547_125",
    x1: 3188.4,
    y1: 344.094,
    x2: 3188.4,
    y2: 282.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7547_125",
    x1: 3162.5,
    y1: 397.281,
    x2: 3162.5,
    y2: 265.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_7547_125",
    x1: 3136.6,
    y1: 391.186,
    x2: 3136.6,
    y2: 332.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7547_125",
    x1: 3110.7,
    y1: 435.573,
    x2: 3110.7,
    y2: 323.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_7547_125",
    x1: 3084.8,
    y1: 481.998,
    x2: 3084.8,
    y2: 314.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_7547_125",
    x1: 3058.9,
    y1: 482.606,
    x2: 3058.9,
    y2: 374.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_7547_125",
    x1: 3032.99,
    y1: 458.94,
    x2: 3032.99,
    y2: 418.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_7547_125",
    x1: 3007.09,
    y1: 553,
    x2: 3007.09,
    y2: 312.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_7547_125",
    x1: 2981.19,
    y1: 457.142,
    x2: 2981.19,
    y2: 375.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_7547_125",
    x1: 2955.29,
    y1: 518.911,
    x2: 2955.29,
    y2: 355.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_7547_125",
    x1: 2929.39,
    y1: 536.405,
    x2: 2929.39,
    y2: 370.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_7547_125",
    x1: 2903.49,
    y1: 474.161,
    x2: 2903.49,
    y2: 366.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_7547_125",
    x1: 2869.02,
    y1: 444.981,
    x2: 2877.56,
    y2: 412.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_7547_125",
    x1: 3965.49,
    y1: 207.774,
    x2: 3965.49,
    y2: 147.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_7547_125",
    x1: 2309.57,
    y1: 333.774,
    x2: 2309.57,
    y2: 273.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_7547_125",
    x1: 3939.59,
    y1: 226.509,
    x2: 3939.59,
    y2: 209.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_7547_125",
    x1: 2335.47,
    y1: 352.509,
    x2: 2335.47,
    y2: 335.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_7547_125",
    x1: 3913.69,
    y1: 248.146,
    x2: 3913.69,
    y2: 232.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_7547_125",
    x1: 2361.37,
    y1: 374.146,
    x2: 2361.37,
    y2: 358.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_7547_125",
    x1: 2869.05,
    y1: 254.742,
    x2: 2869.48,
    y2: 226.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_7547_125",
    x1: 3406,
    y1: 380.742,
    x2: 3405.57,
    y2: 352.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_7547_125",
    x1: 3861.88,
    y1: 269.252,
    x2: 3861.88,
    y2: 244.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_7547_125",
    x1: 2413.17,
    y1: 395.252,
    x2: 2413.17,
    y2: 370.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_7547_125",
    x1: 3835.98,
    y1: 337.327,
    x2: 3835.98,
    y2: 305.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_7547_125",
    x1: 2439.07,
    y1: 463.327,
    x2: 2439.07,
    y2: 431.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_7547_125",
    x1: 3810.08,
    y1: 330.465,
    x2: 3810.08,
    y2: 307.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_7547_125",
    x1: 2464.97,
    y1: 456.465,
    x2: 2464.97,
    y2: 433.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_7547_125",
    x1: 3784.17,
    y1: 318.857,
    x2: 3784.17,
    y2: 262.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_7547_125",
    x1: 2490.88,
    y1: 444.857,
    x2: 2490.88,
    y2: 388.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_7547_125",
    x1: 3758.28,
    y1: 277.167,
    x2: 3758.28,
    y2: 237.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_7547_125",
    x1: 2516.78,
    y1: 403.167,
    x2: 2516.78,
    y2: 363.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_7547_125",
    x1: 3732.37,
    y1: 244.846,
    x2: 3732.37,
    y2: 229.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_7547_125",
    x1: 2542.68,
    y1: 370.846,
    x2: 2542.68,
    y2: 355.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_7547_125",
    x1: 3706.47,
    y1: 240.227,
    x2: 3706.47,
    y2: 218.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_7547_125",
    x1: 2568.58,
    y1: 366.227,
    x2: 2568.58,
    y2: 344.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_7547_125",
    x1: 3680.57,
    y1: 248.805,
    x2: 3680.57,
    y2: 218.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_7547_125",
    x1: 2594.48,
    y1: 374.805,
    x2: 2594.48,
    y2: 344.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_7547_125",
    x1: 3654.67,
    y1: 275.322,
    x2: 3654.67,
    y2: 256.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_7547_125",
    x1: 2620.39,
    y1: 401.322,
    x2: 2620.39,
    y2: 382.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_7547_125",
    x1: 3628.76,
    y1: 275.322,
    x2: 3628.76,
    y2: 242.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_7547_125",
    x1: 2646.29,
    y1: 401.322,
    x2: 2646.29,
    y2: 368.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_7547_125",
    x1: 3602.86,
    y1: 258.697,
    x2: 3602.86,
    y2: 248.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_7547_125",
    x1: 2672.19,
    y1: 384.697,
    x2: 2672.19,
    y2: 374.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_7547_125",
    x1: 3576.96,
    y1: 244.846,
    x2: 3576.96,
    y2: 231.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_7547_125",
    x1: 2698.09,
    y1: 370.846,
    x2: 2698.09,
    y2: 357.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_7547_125",
    x1: 3551.06,
    y1: 244.846,
    x2: 3551.06,
    y2: 217.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_7547_125",
    x1: 2723.99,
    y1: 370.846,
    x2: 2723.99,
    y2: 343.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_7547_125",
    x1: 3525.16,
    y1: 227.827,
    x2: 3525.16,
    y2: 202.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_7547_125",
    x1: 2749.89,
    y1: 353.827,
    x2: 2749.89,
    y2: 328.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_7547_125",
    x1: 3499.26,
    y1: 242.076,
    x2: 3499.26,
    y2: 212.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_7547_125",
    x1: 2775.79,
    y1: 368.076,
    x2: 2775.79,
    y2: 338.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_7547_125",
    x1: 3473.36,
    y1: 227.827,
    x2: 3473.36,
    y2: 191.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_7547_125",
    x1: 2801.69,
    y1: 353.827,
    x2: 2801.69,
    y2: 317.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_7547_125",
    x1: 3447.45,
    y1: 236.632,
    x2: 3447.45,
    y2: 206.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_7547_125",
    x1: 2827.62,
    y1: 362.632,
    x2: 2827.62,
    y2: 332.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_7547_125",
    x1: 3421.55,
    y1: 258.697,
    x2: 3421.55,
    y2: 242.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_7547_125",
    x1: 2853.52,
    y1: 384.697,
    x2: 2853.52,
    y2: 368.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_7547_125",
    x1: 3395.65,
    y1: 248.805,
    x2: 3395.65,
    y2: 224.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_7547_125",
    x1: 3369.75,
    y1: 275.322,
    x2: 3369.75,
    y2: 232.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_7547_125",
    x1: 3343.85,
    y1: 317.273,
    x2: 3343.85,
    y2: 252.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_7547_125",
    x1: 3317.91,
    y1: 402.366,
    x2: 3317.91,
    y2: 311.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_7547_125",
    x1: 3292.01,
    y1: 415.824,
    x2: 3292.01,
    y2: 379.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_7547_125",
    x1: 3266.11,
    y1: 398.411,
    x2: 3266.11,
    y2: 355.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_7547_125",
    x1: 3240.21,
    y1: 366.746,
    x2: 3240.21,
    y2: 327.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_7547_125",
    x1: 3214.31,
    y1: 377.035,
    x2: 3214.31,
    y2: 334.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_7547_125",
    x1: 4589.02,
    y1: 307.17,
    x2: 4589.02,
    y2: 230.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_7547_125",
    x1: 4563.12,
    y1: 333.49,
    x2: 4563.12,
    y2: 148.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_7547_125",
    x1: 4537.22,
    y1: 273.137,
    x2: 4537.22,
    y2: 141.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_7547_125",
    x1: 4511.32,
    y1: 212.447,
    x2: 4511.32,
    y2: 161.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_7547_125",
    x1: 4485.42,
    y1: 214.805,
    x2: 4485.42,
    y2: 144.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_7547_125",
    x1: 4459.52,
    y1: 233.245,
    x2: 4459.52,
    y2: 134.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_7547_125",
    x1: 4433.61,
    y1: 247.169,
    x2: 4433.61,
    y2: 184.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_7547_125",
    x1: 4407.71,
    y1: 263.554,
    x2: 4407.71,
    y2: 153.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_7547_125",
    x1: 4381.81,
    y1: 220.079,
    x2: 4381.81,
    y2: 187.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_7547_125",
    x1: 4355.91,
    y1: 210.546,
    x2: 4355.91,
    y2: 165.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_7547_125",
    x1: 4330.06,
    y1: 226.251,
    x2: 4330.06,
    y2: 136.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_7547_125",
    x1: 4304.16,
    y1: 206.955,
    x2: 4304.16,
    y2: 123.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_7547_125",
    x1: 4278.26,
    y1: 225.754,
    x2: 4278.26,
    y2: 129.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_7547_125",
    x1: 4252.36,
    y1: 219.702,
    x2: 4252.36,
    y2: 99.5399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_7547_125",
    x1: 4226.46,
    y1: 221.337,
    x2: 4226.46,
    y2: 121.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_7547_125",
    x1: 4200.55,
    y1: 227.813,
    x2: 4200.55,
    y2: 172.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_7547_125",
    x1: 4174.65,
    y1: 226.794,
    x2: 4174.65,
    y2: 146.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_7547_125",
    x1: 4148.75,
    y1: 274.477,
    x2: 4148.75,
    y2: 133.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_7547_125",
    x1: 4122.85,
    y1: 341.918,
    x2: 4122.85,
    y2: 127.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_7547_125",
    x1: 4096.95,
    y1: 457.051,
    x2: 4096.95,
    y2: 156.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_7547_125",
    x1: 4071.04,
    y1: 407.698,
    x2: 4071.04,
    y2: 287.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_7547_125",
    x1: 4045.14,
    y1: 397.567,
    x2: 4045.14,
    y2: 256.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_7547_125",
    x1: 4019.24,
    y1: 361.805,
    x2: 4019.24,
    y2: 232.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_7547_125",
    x1: 3993.34,
    y1: 376.195,
    x2: 3993.34,
    y2: 235.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_7547_125",
    x1: 4589.02,
    y1: 280.465,
    x2: 4589.02,
    y2: 257.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_7547_125",
    x1: 4563.12,
    y1: 268.857,
    x2: 4563.12,
    y2: 212.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_7547_125",
    x1: 4537.22,
    y1: 227.167,
    x2: 4537.22,
    y2: 187.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_7547_125",
    x1: 4511.32,
    y1: 194.846,
    x2: 4511.32,
    y2: 179.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_7547_125",
    x1: 4485.42,
    y1: 190.227,
    x2: 4485.42,
    y2: 168.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_7547_125",
    x1: 4459.52,
    y1: 198.805,
    x2: 4459.52,
    y2: 168.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_7547_125",
    x1: 4433.61,
    y1: 225.322,
    x2: 4433.61,
    y2: 206.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_7547_125",
    x1: 4407.71,
    y1: 225.322,
    x2: 4407.71,
    y2: 192.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_7547_125",
    x1: 4381.81,
    y1: 208.697,
    x2: 4381.81,
    y2: 198.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_7547_125",
    x1: 4355.96,
    y1: 194.846,
    x2: 4355.96,
    y2: 181.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_7547_125",
    x1: 4330.06,
    y1: 194.846,
    x2: 4330.06,
    y2: 167.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_7547_125",
    x1: 4304.16,
    y1: 177.827,
    x2: 4304.16,
    y2: 152.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_7547_125",
    x1: 4278.26,
    y1: 192.076,
    x2: 4278.26,
    y2: 162.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_7547_125",
    x1: 4252.36,
    y1: 177.827,
    x2: 4252.36,
    y2: 141.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_7547_125",
    x1: 4226.45,
    y1: 186.632,
    x2: 4226.45,
    y2: 156.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_7547_125",
    x1: 4200.55,
    y1: 208.697,
    x2: 4200.55,
    y2: 192.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_7547_125",
    x1: 4174.65,
    y1: 198.805,
    x2: 4174.65,
    y2: 174.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_7547_125",
    x1: 4148.75,
    y1: 225.322,
    x2: 4148.75,
    y2: 182.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_7547_125",
    x1: 4122.85,
    y1: 267.273,
    x2: 4122.85,
    y2: 202.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_7547_125",
    x1: 4096.95,
    y1: 352.366,
    x2: 4096.95,
    y2: 261.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_7547_125",
    x1: 4071.04,
    y1: 365.824,
    x2: 4071.04,
    y2: 329.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_7547_125",
    x1: 4045.14,
    y1: 348.411,
    x2: 4045.14,
    y2: 305.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_7547_125",
    x1: 4019.24,
    y1: 316.746,
    x2: 4019.24,
    y2: 277.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_7547_125",
    x1: 3993.34,
    y1: 327.035,
    x2: 3993.34,
    y2: 284.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_7547_125",
    x1: 3188.4,
    y1: 322.551,
    x2: 3188.4,
    y2: 303.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_7547_125",
    x1: 3162.5,
    y1: 351.311,
    x2: 3162.5,
    y2: 311.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_7547_125",
    x1: 3136.6,
    y1: 370.705,
    x2: 3136.6,
    y2: 352.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_7547_125",
    x1: 3110.7,
    y1: 396.43,
    x2: 3110.7,
    y2: 362.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_7547_125",
    x1: 3084.8,
    y1: 423.738,
    x2: 3084.8,
    y2: 373.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_7547_125",
    x1: 3058.9,
    y1: 444.981,
    x2: 3058.9,
    y2: 412.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_7547_125",
    x1: 3032.99,
    y1: 444.981,
    x2: 3032.99,
    y2: 432.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_7547_125",
    x1: 3007.09,
    y1: 469.255,
    x2: 3007.09,
    y2: 396.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_7547_125",
    x1: 2981.19,
    y1: 428.622,
    x2: 2981.19,
    y2: 403.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_7547_125",
    x1: 2955.29,
    y1: 461.867,
    x2: 2955.29,
    y2: 412.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_7547_125",
    x1: 2929.39,
    y1: 478.753,
    x2: 2929.39,
    y2: 428.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_7547_125",
    x1: 2903.49,
    y1: 436.536,
    x2: 2903.49,
    y2: 403.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_7547_125",
    x1: 576.584,
    y1: 483.066,
    x2: 576.584,
    y2: 375.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_7547_125",
    x1: 1664.49,
    y1: 217.113,
    x2: 1664.49,
    y2: 19.4601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_7547_125",
    x1: 8.56639,
    y1: 403.113,
    x2: 8.56639,
    y2: 205.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_7547_125",
    x1: 1638.58,
    y1: 246.693,
    x2: 1638.58,
    y2: 190.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_7547_125",
    x1: 34.4691,
    y1: 372.693,
    x2: 34.4691,
    y2: 316.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_7547_125",
    x1: 1612.68,
    y1: 267.114,
    x2: 1612.68,
    y2: 214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_7547_125",
    x1: 60.3682,
    y1: 393.114,
    x2: 60.3682,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_7547_125",
    x1: 1586.78,
    y1: 287.668,
    x2: 1586.78,
    y2: 194.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_7547_125",
    x1: 86.2715,
    y1: 413.668,
    x2: 86.2715,
    y2: 320.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_7547_125",
    x1: 1560.88,
    y1: 297.779,
    x2: 1560.88,
    y2: 217.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_7547_125",
    x1: 112.174,
    y1: 423.779,
    x2: 112.174,
    y2: 343.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_7547_125",
    x1: 1534.98,
    y1: 374.807,
    x2: 1534.98,
    y2: 268.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_7547_125",
    x1: 138.071,
    y1: 500.807,
    x2: 138.071,
    y2: 394.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_7547_125",
    x1: 1509.08,
    y1: 357.63,
    x2: 1509.08,
    y2: 281.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_7547_125",
    x1: 163.975,
    y1: 483.63,
    x2: 163.975,
    y2: 407.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_7547_125",
    x1: 1483.17,
    y1: 383.95,
    x2: 1483.17,
    y2: 198.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_7547_125",
    x1: 189.878,
    y1: 509.95,
    x2: 189.878,
    y2: 324.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_7547_125",
    x1: 1457.27,
    y1: 323.598,
    x2: 1457.27,
    y2: 191.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_7547_125",
    x1: 215.776,
    y1: 309.598,
    x2: 215.776,
    y2: 177.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_7547_125",
    x1: 1431.37,
    y1: 262.907,
    x2: 1431.37,
    y2: 212.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_7547_125",
    x1: 241.68,
    y1: 318.907,
    x2: 241.68,
    y2: 268.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_7547_125",
    x1: 1405.47,
    y1: 265.265,
    x2: 1405.47,
    y2: 194.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_7547_125",
    x1: 267.583,
    y1: 391.265,
    x2: 267.583,
    y2: 320.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_7547_125",
    x1: 1379.57,
    y1: 283.705,
    x2: 1379.57,
    y2: 184.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_7547_125",
    x1: 293.482,
    y1: 409.705,
    x2: 293.482,
    y2: 310.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_7547_125",
    x1: 1353.66,
    y1: 297.629,
    x2: 1353.66,
    y2: 234.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_7547_125",
    x1: 319.385,
    y1: 423.629,
    x2: 319.385,
    y2: 360.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_7547_125",
    x1: 345.288,
    y1: 440.014,
    x2: 345.288,
    y2: 330.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_7547_125",
    x1: 371.187,
    y1: 396.539,
    x2: 371.187,
    y2: 363.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_7547_125",
    x1: 397.09,
    y1: 387.006,
    x2: 397.09,
    y2: 341.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_7547_125",
    x1: 422.994,
    y1: 402.711,
    x2: 422.994,
    y2: 312.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_7547_125",
    x1: 448.893,
    y1: 383.415,
    x2: 448.893,
    y2: 299.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_7547_125",
    x1: 474.795,
    y1: 402.214,
    x2: 474.795,
    y2: 305.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_7547_125",
    x1: 500.694,
    y1: 316.162,
    x2: 500.694,
    y2: 196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_7547_125",
    x1: 526.617,
    y1: 367.797,
    x2: 526.617,
    y2: 268.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_7547_125",
    x1: 552.52,
    y1: 404.273,
    x2: 552.52,
    y2: 349.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_7547_125",
    x1: 835.599,
    y1: 391.646,
    x2: 835.599,
    y2: 332.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_7547_125",
    x1: 809.695,
    y1: 436.033,
    x2: 809.695,
    y2: 323.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_7547_125",
    x1: 783.797,
    y1: 482.458,
    x2: 783.797,
    y2: 315.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_7547_125",
    x1: 757.893,
    y1: 483.066,
    x2: 757.893,
    y2: 375.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_7547_125",
    x1: 731.99,
    y1: 459.4,
    x2: 731.99,
    y2: 419.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_7547_125",
    x1: 706.092,
    y1: 553.46,
    x2: 706.092,
    y2: 313.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_7547_125",
    x1: 680.188,
    y1: 457.602,
    x2: 680.188,
    y2: 375.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_7547_125",
    x1: 654.285,
    y1: 519.372,
    x2: 654.285,
    y2: 355.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_7547_125",
    x1: 628.387,
    y1: 536.865,
    x2: 628.387,
    y2: 371.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_7547_125",
    x1: 602.487,
    y1: 474.621,
    x2: 602.487,
    y2: 366.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_7547_125",
    x1: 568.018,
    y1: 445.442,
    x2: 576.558,
    y2: 412.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_7547_125",
    x1: 1664.49,
    y1: 148.234,
    x2: 1664.49,
    y2: 88.3392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_7547_125",
    x1: 8.56605,
    y1: 334.234,
    x2: 8.56605,
    y2: 274.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_7547_125",
    x1: 1638.58,
    y1: 226.969,
    x2: 1638.58,
    y2: 209.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_7547_125",
    x1: 34.4694,
    y1: 352.969,
    x2: 34.4694,
    y2: 335.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_7547_125",
    x1: 1612.68,
    y1: 248.606,
    x2: 1612.68,
    y2: 232.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_7547_125",
    x1: 60.3687,
    y1: 374.606,
    x2: 60.3687,
    y2: 358.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_7547_125",
    x1: 568.052,
    y1: 255.202,
    x2: 568.479,
    y2: 226.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_7547_125",
    x1: 1105,
    y1: 381.202,
    x2: 1104.57,
    y2: 352.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_7547_125",
    x1: 1560.88,
    y1: 269.712,
    x2: 1560.88,
    y2: 245.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_7547_125",
    x1: 112.174,
    y1: 395.712,
    x2: 112.174,
    y2: 371.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_7547_125",
    x1: 1534.98,
    y1: 337.787,
    x2: 1534.98,
    y2: 305.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_7547_125",
    x1: 138.072,
    y1: 463.787,
    x2: 138.072,
    y2: 431.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_7547_125",
    x1: 1509.07,
    y1: 330.926,
    x2: 1509.07,
    y2: 307.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_7547_125",
    x1: 163.975,
    y1: 456.926,
    x2: 163.975,
    y2: 433.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_7547_125",
    x1: 1483.17,
    y1: 319.317,
    x2: 1483.17,
    y2: 263.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_7547_125",
    x1: 189.878,
    y1: 445.317,
    x2: 189.878,
    y2: 389.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_7547_125",
    x1: 1457.27,
    y1: 277.627,
    x2: 1457.27,
    y2: 237.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_7547_125",
    x1: 215.777,
    y1: 263.627,
    x2: 215.777,
    y2: 223.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_7547_125",
    x1: 1431.37,
    y1: 245.306,
    x2: 1431.37,
    y2: 229.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_7547_125",
    x1: 241.68,
    y1: 301.306,
    x2: 241.68,
    y2: 285.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_7547_125",
    x1: 1405.47,
    y1: 240.687,
    x2: 1405.47,
    y2: 219.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_7547_125",
    x1: 267.584,
    y1: 366.687,
    x2: 267.584,
    y2: 345.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_7547_125",
    x1: 1379.57,
    y1: 249.265,
    x2: 1379.57,
    y2: 219.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_7547_125",
    x1: 293.482,
    y1: 375.265,
    x2: 293.482,
    y2: 345.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_7547_125",
    x1: 319.385,
    y1: 401.782,
    x2: 319.385,
    y2: 382.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_7547_125",
    x1: 345.289,
    y1: 401.782,
    x2: 345.289,
    y2: 368.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_7547_125",
    x1: 371.187,
    y1: 385.157,
    x2: 371.187,
    y2: 375.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_7547_125",
    x1: 397.09,
    y1: 371.306,
    x2: 397.09,
    y2: 357.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_7547_125",
    x1: 422.994,
    y1: 371.306,
    x2: 422.994,
    y2: 343.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_7547_125",
    x1: 448.892,
    y1: 354.287,
    x2: 448.892,
    y2: 328.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_7547_125",
    x1: 474.791,
    y1: 368.537,
    x2: 474.791,
    y2: 339.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_7547_125",
    x1: 500.695,
    y1: 274.287,
    x2: 500.695,
    y2: 237.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_7547_125",
    x1: 526.617,
    y1: 333.092,
    x2: 526.617,
    y2: 302.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_7547_125",
    x1: 552.52,
    y1: 385.157,
    x2: 552.52,
    y2: 368.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_7547_125",
    x1: 2288.02,
    y1: 347.63,
    x2: 2288.02,
    y2: 271.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_7547_125",
    x1: 2262.12,
    y1: 373.95,
    x2: 2262.12,
    y2: 188.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_7547_125",
    x1: 2236.22,
    y1: 273.598,
    x2: 2236.22,
    y2: 141.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_7547_125",
    x1: 2210.32,
    y1: 212.907,
    x2: 2210.32,
    y2: 162.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_7547_125",
    x1: 2184.42,
    y1: 215.265,
    x2: 2184.42,
    y2: 144.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_7547_125",
    x1: 2158.52,
    y1: 233.705,
    x2: 2158.52,
    y2: 134.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_7547_125",
    x1: 2132.61,
    y1: 247.629,
    x2: 2132.61,
    y2: 184.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_7547_125",
    x1: 2106.71,
    y1: 264.014,
    x2: 2106.71,
    y2: 154.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_7547_125",
    x1: 2080.81,
    y1: 220.539,
    x2: 2080.81,
    y2: 187.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_7547_125",
    x1: 2054.91,
    y1: 211.006,
    x2: 2054.91,
    y2: 165.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_7547_125",
    x1: 2029.06,
    y1: 226.711,
    x2: 2029.06,
    y2: 136.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_7547_125",
    x1: 2003.16,
    y1: 207.415,
    x2: 2003.16,
    y2: 123.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_7547_125",
    x1: 1977.25,
    y1: 226.214,
    x2: 1977.25,
    y2: 129.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_7547_125",
    x1: 1951.36,
    y1: 120.162,
    x2: 1951.36,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_7547_125",
    x1: 1925.45,
    y1: 161.797,
    x2: 1925.45,
    y2: 62.2107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_7547_125",
    x1: 1899.55,
    y1: 228.273,
    x2: 1899.55,
    y2: 173.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_7547_125",
    x1: 1873.65,
    y1: 227.254,
    x2: 1873.65,
    y2: 146.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_7547_125",
    x1: 1847.75,
    y1: 274.937,
    x2: 1847.75,
    y2: 133.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_7547_125",
    x1: 1821.84,
    y1: 342.378,
    x2: 1821.84,
    y2: 128.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_7547_125",
    x1: 1795.95,
    y1: 457.511,
    x2: 1795.95,
    y2: 157.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_7547_125",
    x1: 1770.04,
    y1: 408.158,
    x2: 1770.04,
    y2: 287.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_7547_125",
    x1: 1744.14,
    y1: 398.027,
    x2: 1744.14,
    y2: 256.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_7547_125",
    x1: 1718.24,
    y1: 312.265,
    x2: 1718.24,
    y2: 182.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_7547_125",
    x1: 1692.34,
    y1: 226.655,
    x2: 1692.34,
    y2: 85.5968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_7547_125",
    x1: 2288.02,
    y1: 320.926,
    x2: 2288.02,
    y2: 297.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_7547_125",
    x1: 2262.12,
    y1: 309.317,
    x2: 2262.12,
    y2: 253.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_7547_125",
    x1: 2236.22,
    y1: 227.627,
    x2: 2236.22,
    y2: 187.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_7547_125",
    x1: 2210.32,
    y1: 195.306,
    x2: 2210.32,
    y2: 179.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_7547_125",
    x1: 2184.42,
    y1: 190.688,
    x2: 2184.42,
    y2: 169.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_7547_125",
    x1: 2158.52,
    y1: 199.265,
    x2: 2158.52,
    y2: 169.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_7547_125",
    x1: 2132.61,
    y1: 225.782,
    x2: 2132.61,
    y2: 206.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_7547_125",
    x1: 2106.71,
    y1: 225.782,
    x2: 2106.71,
    y2: 192.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_7547_125",
    x1: 2080.81,
    y1: 209.157,
    x2: 2080.81,
    y2: 199.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_7547_125",
    x1: 2054.96,
    y1: 195.306,
    x2: 2054.96,
    y2: 181.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_7547_125",
    x1: 2029.06,
    y1: 195.306,
    x2: 2029.06,
    y2: 167.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_7547_125",
    x1: 2003.16,
    y1: 178.287,
    x2: 2003.16,
    y2: 152.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_7547_125",
    x1: 1977.26,
    y1: 192.537,
    x2: 1977.26,
    y2: 163.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_7547_125",
    x1: 1951.35,
    y1: 78.2873,
    x2: 1951.35,
    y2: 41.8745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_7547_125",
    x1: 1925.45,
    y1: 127.092,
    x2: 1925.45,
    y2: 96.9156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_7547_125",
    x1: 1899.55,
    y1: 209.157,
    x2: 1899.55,
    y2: 192.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_7547_125",
    x1: 1873.65,
    y1: 199.265,
    x2: 1873.65,
    y2: 174.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_7547_125",
    x1: 1847.75,
    y1: 225.782,
    x2: 1847.75,
    y2: 183.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_7547_125",
    x1: 1821.84,
    y1: 267.734,
    x2: 1821.84,
    y2: 202.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_7547_125",
    x1: 1795.94,
    y1: 352.826,
    x2: 1795.94,
    y2: 261.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_7547_125",
    x1: 1770.04,
    y1: 366.284,
    x2: 1770.04,
    y2: 329.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_7547_125",
    x1: 1744.14,
    y1: 348.871,
    x2: 1744.14,
    y2: 306.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_7547_125",
    x1: 1718.24,
    y1: 267.206,
    x2: 1718.24,
    y2: 228.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_7547_125",
    x1: 1692.34,
    y1: 177.495,
    x2: 1692.34,
    y2: 134.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_7547_125",
    x1: 857.405,
    y1: 314.014,
    x2: 857.405,
    y2: 204.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_7547_125",
    x1: 883.303,
    y1: 270.539,
    x2: 883.303,
    y2: 237.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_7547_125",
    x1: 909.206,
    y1: 261.006,
    x2: 909.206,
    y2: 215.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_7547_125",
    x1: 935.11,
    y1: 276.711,
    x2: 935.11,
    y2: 186.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_7547_125",
    x1: 961.008,
    y1: 257.415,
    x2: 961.008,
    y2: 173.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_7547_125",
    x1: 986.911,
    y1: 276.214,
    x2: 986.911,
    y2: 179.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_7547_125",
    x1: 1012.81,
    y1: 270.162,
    x2: 1012.81,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_7547_125",
    x1: 1038.76,
    y1: 271.797,
    x2: 1038.76,
    y2: 172.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_7547_125",
    x1: 1064.66,
    y1: 278.273,
    x2: 1064.66,
    y2: 223.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_7547_125",
    x1: 1090.56,
    y1: 277.254,
    x2: 1090.56,
    y2: 196.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_7547_125",
    x1: 1116.46,
    y1: 324.937,
    x2: 1116.46,
    y2: 183.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_7547_125",
    x1: 1142.37,
    y1: 392.378,
    x2: 1142.37,
    y2: 178.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_7547_125",
    x1: 1168.25,
    y1: 507.511,
    x2: 1168.25,
    y2: 207.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_7547_125",
    x1: 1194.16,
    y1: 458.158,
    x2: 1194.16,
    y2: 337.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_7547_125",
    x1: 1220.06,
    y1: 448.027,
    x2: 1220.06,
    y2: 306.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_7547_125",
    x1: 1245.96,
    y1: 412.265,
    x2: 1245.96,
    y2: 282.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_7547_125",
    x1: 1271.86,
    y1: 426.655,
    x2: 1271.86,
    y2: 285.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_7547_125",
    x1: 1297.77,
    y1: 344.554,
    x2: 1297.77,
    y2: 282.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_7547_125",
    x1: 1323.66,
    y1: 397.742,
    x2: 1323.66,
    y2: 265.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_7547_125",
    x1: 831.501,
    y1: 275.782,
    x2: 831.501,
    y2: 256.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_7547_125",
    x1: 857.405,
    y1: 275.782,
    x2: 857.405,
    y2: 242.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_7547_125",
    x1: 883.303,
    y1: 259.157,
    x2: 883.303,
    y2: 249.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_7547_125",
    x1: 909.206,
    y1: 245.306,
    x2: 909.206,
    y2: 231.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_7547_125",
    x1: 935.11,
    y1: 245.306,
    x2: 935.11,
    y2: 217.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_7547_125",
    x1: 961.008,
    y1: 228.287,
    x2: 961.008,
    y2: 202.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_7547_125",
    x1: 986.906,
    y1: 242.537,
    x2: 986.906,
    y2: 213.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_7547_125",
    x1: 1012.81,
    y1: 228.287,
    x2: 1012.81,
    y2: 191.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_7547_125",
    x1: 1038.76,
    y1: 237.092,
    x2: 1038.76,
    y2: 206.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_7547_125",
    x1: 1064.66,
    y1: 259.157,
    x2: 1064.66,
    y2: 242.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_7547_125",
    x1: 1090.56,
    y1: 249.265,
    x2: 1090.56,
    y2: 224.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_7547_125",
    x1: 1116.46,
    y1: 275.782,
    x2: 1116.46,
    y2: 233.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_7547_125",
    x1: 1142.36,
    y1: 317.733,
    x2: 1142.36,
    y2: 252.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_7547_125",
    x1: 1168.25,
    y1: 402.826,
    x2: 1168.25,
    y2: 311.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_7547_125",
    x1: 1194.16,
    y1: 416.284,
    x2: 1194.16,
    y2: 379.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_7547_125",
    x1: 1220.06,
    y1: 398.871,
    x2: 1220.06,
    y2: 356.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_7547_125",
    x1: 1245.96,
    y1: 367.206,
    x2: 1245.96,
    y2: 328.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_7547_125",
    x1: 1271.86,
    y1: 377.495,
    x2: 1271.86,
    y2: 334.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_7547_125",
    x1: 1297.77,
    y1: 323.011,
    x2: 1297.77,
    y2: 304.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_7547_125",
    x1: 1323.66,
    y1: 351.771,
    x2: 1323.66,
    y2: 311.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_7547_125",
    x1: 835.599,
    y1: 371.165,
    x2: 835.599,
    y2: 353.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_7547_125",
    x1: 809.695,
    y1: 396.89,
    x2: 809.695,
    y2: 362.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_7547_125",
    x1: 783.796,
    y1: 424.198,
    x2: 783.796,
    y2: 373.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_7547_125",
    x1: 757.893,
    y1: 445.442,
    x2: 757.893,
    y2: 412.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_7547_125",
    x1: 731.99,
    y1: 445.442,
    x2: 731.99,
    y2: 433.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_7547_125",
    x1: 706.091,
    y1: 469.715,
    x2: 706.091,
    y2: 396.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_7547_125",
    x1: 680.188,
    y1: 429.082,
    x2: 680.188,
    y2: 404.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_7547_125",
    x1: 654.285,
    y1: 462.327,
    x2: 654.285,
    y2: 412.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_7547_125",
    x1: 628.386,
    y1: 479.213,
    x2: 628.386,
    y2: 429.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_7547_125",
    x1: 602.488,
    y1: 436.996,
    x2: 602.488,
    y2: 404.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_7547_125",
    x1: 5179.61,
    y1: 70.3944,
    x2: 5179.61,
    y2: 178.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_7547_125",
    x1: 6267.45,
    y1: 336.347,
    x2: 6267.45,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_7547_125",
    x1: 4611.57,
    y1: 150.347,
    x2: 4611.57,
    y2: 348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_7547_125",
    x1: 6241.54,
    y1: 306.767,
    x2: 6241.54,
    y2: 363.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_7547_125",
    x1: 4637.47,
    y1: 180.767,
    x2: 4637.47,
    y2: 237.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_7547_125",
    x1: 6215.65,
    y1: 286.346,
    x2: 6215.65,
    y2: 339.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_7547_125",
    x1: 4663.37,
    y1: 160.346,
    x2: 4663.37,
    y2: 213.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_7547_125",
    x1: 6189.74,
    y1: 265.792,
    x2: 6189.74,
    y2: 358.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_7547_125",
    x1: 4689.27,
    y1: 139.792,
    x2: 4689.27,
    y2: 232.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_7547_125",
    x1: 6163.84,
    y1: 255.682,
    x2: 6163.84,
    y2: 336.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_7547_125",
    x1: 4715.17,
    y1: 129.681,
    x2: 4715.17,
    y2: 210.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_7547_125",
    x1: 6137.94,
    y1: 178.653,
    x2: 6137.94,
    y2: 284.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_7547_125",
    x1: 4741.07,
    y1: 52.6526,
    x2: 4741.07,
    y2: 158.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_7547_125",
    x1: 6112.04,
    y1: 195.83,
    x2: 6112.04,
    y2: 272.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_7547_125",
    x1: 4766.98,
    y1: 69.8296,
    x2: 4766.98,
    y2: 146.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_7547_125",
    x1: 6086.13,
    y1: 169.51,
    x2: 6086.13,
    y2: 354.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_7547_125",
    x1: 4792.88,
    y1: 43.5098,
    x2: 4792.88,
    y2: 228.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_7547_125",
    x1: 6060.24,
    y1: 229.863,
    x2: 6060.24,
    y2: 361.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_7547_125",
    x1: 4818.78,
    y1: 243.863,
    x2: 4818.78,
    y2: 375.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_7547_125",
    x1: 6034.33,
    y1: 290.553,
    x2: 6034.33,
    y2: 341.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_7547_125",
    x1: 4844.68,
    y1: 234.553,
    x2: 4844.68,
    y2: 285.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_7547_125",
    x1: 6008.43,
    y1: 288.195,
    x2: 6008.43,
    y2: 358.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_7547_125",
    x1: 4870.58,
    y1: 162.195,
    x2: 4870.58,
    y2: 232.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_7547_125",
    x1: 5982.53,
    y1: 269.755,
    x2: 5982.53,
    y2: 368.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_7547_125",
    x1: 4896.48,
    y1: 143.755,
    x2: 4896.48,
    y2: 242.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_7547_125",
    x1: 5956.63,
    y1: 255.831,
    x2: 5956.63,
    y2: 318.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_7547_125",
    x1: 4922.39,
    y1: 129.831,
    x2: 4922.39,
    y2: 192.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_7547_125",
    x1: 4948.29,
    y1: 113.446,
    x2: 4948.29,
    y2: 223.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_7547_125",
    x1: 4974.19,
    y1: 156.921,
    x2: 4974.19,
    y2: 189.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_7547_125",
    x1: 5000.09,
    y1: 166.454,
    x2: 5000.09,
    y2: 211.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_7547_125",
    x1: 5025.99,
    y1: 150.749,
    x2: 5025.99,
    y2: 240.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_7547_125",
    x1: 5051.89,
    y1: 170.045,
    x2: 5051.89,
    y2: 253.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_7547_125",
    x1: 5077.8,
    y1: 151.246,
    x2: 5077.8,
    y2: 247.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_7547_125",
    x1: 5103.7,
    y1: 207.298,
    x2: 5103.7,
    y2: 327.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_7547_125",
    x1: 5129.64,
    y1: 185.663,
    x2: 5129.64,
    y2: 285.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_7547_125",
    x1: 5155.55,
    y1: 149.187,
    x2: 5155.55,
    y2: 204.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_7547_125",
    x1: 5438.63,
    y1: 161.814,
    x2: 5438.63,
    y2: 220.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_7547_125",
    x1: 5412.72,
    y1: 117.427,
    x2: 5412.72,
    y2: 229.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_7547_125",
    x1: 5386.82,
    y1: 71.0022,
    x2: 5386.82,
    y2: 238.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_7547_125",
    x1: 5360.92,
    y1: 70.3944,
    x2: 5360.92,
    y2: 178.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_7547_125",
    x1: 5335.02,
    y1: 94.0603,
    x2: 5335.02,
    y2: 134.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_7547_125",
    x1: 5309.12,
    y1: 0,
    x2: 5309.12,
    y2: 240.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_7547_125",
    x1: 5283.22,
    y1: 95.8581,
    x2: 5283.22,
    y2: 177.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_7547_125",
    x1: 5257.31,
    y1: 34.0885,
    x2: 5257.31,
    y2: 197.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_7547_125",
    x1: 5231.41,
    y1: 16.5948,
    x2: 5231.41,
    y2: 182.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_7547_125",
    x1: 5205.51,
    y1: 78.8395,
    x2: 5205.51,
    y2: 186.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_7547_125",
    x1: 5171.05,
    y1: 108.019,
    x2: 5179.59,
    y2: 140.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_7547_125",
    x1: 6267.45,
    y1: 405.226,
    x2: 6267.45,
    y2: 465.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_7547_125",
    x1: 4611.57,
    y1: 219.226,
    x2: 4611.57,
    y2: 279.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_7547_125",
    x1: 6241.54,
    y1: 326.491,
    x2: 6241.54,
    y2: 343.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_7547_125",
    x1: 4637.47,
    y1: 200.491,
    x2: 4637.47,
    y2: 217.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_7547_125",
    x1: 6215.65,
    y1: 304.854,
    x2: 6215.65,
    y2: 320.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_7547_125",
    x1: 4663.37,
    y1: 178.854,
    x2: 4663.37,
    y2: 194.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_7547_125",
    x1: 5171.01,
    y1: 298.258,
    x2: 5171.44,
    y2: 326.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_7547_125",
    x1: 5708,
    y1: 172.258,
    x2: 5707.57,
    y2: 200.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_7547_125",
    x1: 6163.84,
    y1: 283.748,
    x2: 6163.84,
    y2: 308.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_7547_125",
    x1: 4715.17,
    y1: 157.748,
    x2: 4715.17,
    y2: 182.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_7547_125",
    x1: 6137.94,
    y1: 215.673,
    x2: 6137.94,
    y2: 247.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_7547_125",
    x1: 4741.07,
    y1: 89.6732,
    x2: 4741.07,
    y2: 121.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_7547_125",
    x1: 6112.04,
    y1: 222.535,
    x2: 6112.04,
    y2: 245.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_7547_125",
    x1: 4766.98,
    y1: 96.5346,
    x2: 4766.98,
    y2: 119.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_7547_125",
    x1: 6086.13,
    y1: 234.143,
    x2: 6086.13,
    y2: 290.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_7547_125",
    x1: 4792.88,
    y1: 108.143,
    x2: 4792.88,
    y2: 164.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_7547_125",
    x1: 6060.24,
    y1: 275.833,
    x2: 6060.24,
    y2: 315.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_7547_125",
    x1: 4818.78,
    y1: 289.833,
    x2: 4818.78,
    y2: 329.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_7547_125",
    x1: 6034.33,
    y1: 308.154,
    x2: 6034.33,
    y2: 323.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_7547_125",
    x1: 4844.68,
    y1: 252.154,
    x2: 4844.68,
    y2: 267.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_7547_125",
    x1: 6008.43,
    y1: 312.773,
    x2: 6008.43,
    y2: 334.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_7547_125",
    x1: 4870.58,
    y1: 186.773,
    x2: 4870.58,
    y2: 208.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_7547_125",
    x1: 5982.53,
    y1: 304.195,
    x2: 5982.53,
    y2: 334.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_7547_125",
    x1: 4896.48,
    y1: 178.195,
    x2: 4896.48,
    y2: 208.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_7547_125",
    x1: 4922.39,
    y1: 151.678,
    x2: 4922.39,
    y2: 170.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_7547_125",
    x1: 4948.29,
    y1: 151.678,
    x2: 4948.29,
    y2: 184.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_7547_125",
    x1: 4974.19,
    y1: 168.303,
    x2: 4974.19,
    y2: 178.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_7547_125",
    x1: 5000.09,
    y1: 182.154,
    x2: 5000.09,
    y2: 195.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_7547_125",
    x1: 5026,
    y1: 182.154,
    x2: 5026,
    y2: 209.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_7547_125",
    x1: 5051.89,
    y1: 199.173,
    x2: 5051.89,
    y2: 224.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_7547_125",
    x1: 5077.79,
    y1: 184.924,
    x2: 5077.79,
    y2: 214.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_7547_125",
    x1: 5103.7,
    y1: 249.173,
    x2: 5103.7,
    y2: 285.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_7547_125",
    x1: 5129.64,
    y1: 220.368,
    x2: 5129.64,
    y2: 250.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_7547_125",
    x1: 5155.55,
    y1: 168.303,
    x2: 5155.55,
    y2: 184.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_7547_125",
    x1: 6891.02,
    y1: 205.83,
    x2: 6891.02,
    y2: 282.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_7547_125",
    x1: 6865.12,
    y1: 179.51,
    x2: 6865.12,
    y2: 364.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_7547_125",
    x1: 6839.22,
    y1: 279.863,
    x2: 6839.22,
    y2: 411.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_7547_125",
    x1: 6813.32,
    y1: 340.553,
    x2: 6813.32,
    y2: 391.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_7547_125",
    x1: 6787.42,
    y1: 338.195,
    x2: 6787.42,
    y2: 408.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_7547_125",
    x1: 6761.52,
    y1: 319.755,
    x2: 6761.52,
    y2: 418.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_7547_125",
    x1: 6735.61,
    y1: 305.831,
    x2: 6735.61,
    y2: 368.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_7547_125",
    x1: 6709.71,
    y1: 289.446,
    x2: 6709.71,
    y2: 399.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_7547_125",
    x1: 6683.81,
    y1: 332.921,
    x2: 6683.81,
    y2: 365.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_7547_125",
    x1: 6657.91,
    y1: 342.454,
    x2: 6657.91,
    y2: 387.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_7547_125",
    x1: 6632.02,
    y1: 326.749,
    x2: 6632.02,
    y2: 416.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_7547_125",
    x1: 6606.12,
    y1: 346.045,
    x2: 6606.12,
    y2: 429.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_7547_125",
    x1: 6580.22,
    y1: 327.246,
    x2: 6580.22,
    y2: 423.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_7547_125",
    x1: 6554.32,
    y1: 433.298,
    x2: 6554.32,
    y2: 553.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_7547_125",
    x1: 6528.41,
    y1: 391.663,
    x2: 6528.41,
    y2: 491.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_7547_125",
    x1: 6502.51,
    y1: 325.187,
    x2: 6502.51,
    y2: 380.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_7547_125",
    x1: 6476.61,
    y1: 326.206,
    x2: 6476.61,
    y2: 406.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_7547_125",
    x1: 6891.02,
    y1: 232.535,
    x2: 6891.02,
    y2: 255.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_7547_125",
    x1: 6865.12,
    y1: 244.143,
    x2: 6865.12,
    y2: 300.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_7547_125",
    x1: 6839.22,
    y1: 325.833,
    x2: 6839.22,
    y2: 365.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_7547_125",
    x1: 6813.32,
    y1: 358.154,
    x2: 6813.32,
    y2: 373.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_7547_125",
    x1: 6787.42,
    y1: 362.773,
    x2: 6787.42,
    y2: 384.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_7547_125",
    x1: 6761.52,
    y1: 354.195,
    x2: 6761.52,
    y2: 384.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_7547_125",
    x1: 6735.61,
    y1: 327.678,
    x2: 6735.61,
    y2: 346.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_7547_125",
    x1: 6709.71,
    y1: 327.678,
    x2: 6709.71,
    y2: 360.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_7547_125",
    x1: 6683.81,
    y1: 344.303,
    x2: 6683.81,
    y2: 354.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_7547_125",
    x1: 6657.92,
    y1: 358.154,
    x2: 6657.92,
    y2: 371.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_7547_125",
    x1: 6632.02,
    y1: 358.154,
    x2: 6632.02,
    y2: 385.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_7547_125",
    x1: 6606.12,
    y1: 375.173,
    x2: 6606.12,
    y2: 400.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_7547_125",
    x1: 6580.22,
    y1: 360.924,
    x2: 6580.22,
    y2: 390.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_7547_125",
    x1: 6554.32,
    y1: 475.173,
    x2: 6554.32,
    y2: 511.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_7547_125",
    x1: 6528.41,
    y1: 426.368,
    x2: 6528.41,
    y2: 456.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_7547_125",
    x1: 6502.51,
    y1: 344.303,
    x2: 6502.51,
    y2: 360.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_7547_125",
    x1: 6476.61,
    y1: 354.195,
    x2: 6476.61,
    y2: 378.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_7547_125",
    x1: 6295.3,
    y1: 278.523,
    x2: 6295.3,
    y2: 419.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_7547_125",
    x1: 6321.2,
    y1: 211.082,
    x2: 6321.2,
    y2: 425.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_7547_125",
    x1: 6347.1,
    y1: 95.9495,
    x2: 6347.1,
    y2: 396.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_7547_125",
    x1: 6373,
    y1: 145.302,
    x2: 6373,
    y2: 265.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_7547_125",
    x1: 6398.91,
    y1: 155.433,
    x2: 6398.91,
    y2: 296.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_7547_125",
    x1: 6424.8,
    y1: 241.195,
    x2: 6424.8,
    y2: 370.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_7547_125",
    x1: 6450.71,
    y1: 326.805,
    x2: 6450.71,
    y2: 467.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_7547_125",
    x1: 6295.3,
    y1: 327.678,
    x2: 6295.3,
    y2: 370.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_7547_125",
    x1: 6321.2,
    y1: 285.727,
    x2: 6321.2,
    y2: 350.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_7547_125",
    x1: 6347.1,
    y1: 200.634,
    x2: 6347.1,
    y2: 291.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_7547_125",
    x1: 6373,
    y1: 187.176,
    x2: 6373,
    y2: 223.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_7547_125",
    x1: 6398.91,
    y1: 204.589,
    x2: 6398.91,
    y2: 247.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_7547_125",
    x1: 6424.8,
    y1: 286.254,
    x2: 6424.8,
    y2: 325.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_7547_125",
    x1: 6450.71,
    y1: 375.965,
    x2: 6450.71,
    y2: 418.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_7547_125",
    x1: 5460.43,
    y1: 239.446,
    x2: 5460.43,
    y2: 349.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_7547_125",
    x1: 5486.33,
    y1: 282.922,
    x2: 5486.33,
    y2: 315.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_7547_125",
    x1: 5512.23,
    y1: 292.454,
    x2: 5512.23,
    y2: 337.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_7547_125",
    x1: 5538.14,
    y1: 276.749,
    x2: 5538.14,
    y2: 366.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_7547_125",
    x1: 5564.04,
    y1: 296.045,
    x2: 5564.04,
    y2: 379.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_7547_125",
    x1: 5589.94,
    y1: 277.246,
    x2: 5589.94,
    y2: 373.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_7547_125",
    x1: 5615.84,
    y1: 283.298,
    x2: 5615.84,
    y2: 403.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_7547_125",
    x1: 5641.72,
    y1: 281.663,
    x2: 5641.72,
    y2: 381.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_7547_125",
    x1: 5667.62,
    y1: 275.187,
    x2: 5667.62,
    y2: 330.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_7547_125",
    x1: 5693.52,
    y1: 276.206,
    x2: 5693.52,
    y2: 356.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_7547_125",
    x1: 5719.42,
    y1: 228.523,
    x2: 5719.42,
    y2: 369.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_7547_125",
    x1: 5745.33,
    y1: 161.082,
    x2: 5745.33,
    y2: 375.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_7547_125",
    x1: 5771.22,
    y1: 45.9494,
    x2: 5771.22,
    y2: 346.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_7547_125",
    x1: 5797.12,
    y1: 95.3017,
    x2: 5797.12,
    y2: 215.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_7547_125",
    x1: 5823.02,
    y1: 105.433,
    x2: 5823.02,
    y2: 246.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_7547_125",
    x1: 5848.92,
    y1: 141.195,
    x2: 5848.92,
    y2: 270.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_7547_125",
    x1: 5874.82,
    y1: 126.805,
    x2: 5874.82,
    y2: 267.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_7547_125",
    x1: 5900.73,
    y1: 208.906,
    x2: 5900.73,
    y2: 270.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_7547_125",
    x1: 5926.63,
    y1: 155.719,
    x2: 5926.63,
    y2: 287.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_7547_125",
    x1: 5460.43,
    y1: 277.678,
    x2: 5460.43,
    y2: 310.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_7547_125",
    x1: 5486.33,
    y1: 294.303,
    x2: 5486.33,
    y2: 304.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_7547_125",
    x1: 5512.23,
    y1: 308.154,
    x2: 5512.23,
    y2: 321.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_7547_125",
    x1: 5538.14,
    y1: 308.154,
    x2: 5538.14,
    y2: 335.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_7547_125",
    x1: 5564.03,
    y1: 325.173,
    x2: 5564.03,
    y2: 350.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_7547_125",
    x1: 5589.93,
    y1: 310.924,
    x2: 5589.93,
    y2: 340.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_7547_125",
    x1: 5615.84,
    y1: 325.173,
    x2: 5615.84,
    y2: 361.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_7547_125",
    x1: 5641.72,
    y1: 316.368,
    x2: 5641.72,
    y2: 346.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_7547_125",
    x1: 5667.62,
    y1: 294.303,
    x2: 5667.62,
    y2: 310.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_7547_125",
    x1: 5693.52,
    y1: 304.195,
    x2: 5693.52,
    y2: 328.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_7547_125",
    x1: 5719.42,
    y1: 277.678,
    x2: 5719.42,
    y2: 320.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_7547_125",
    x1: 5745.33,
    y1: 235.727,
    x2: 5745.33,
    y2: 300.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint516_linear_7547_125",
    x1: 5771.22,
    y1: 150.634,
    x2: 5771.22,
    y2: 241.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint517_linear_7547_125",
    x1: 5797.12,
    y1: 137.176,
    x2: 5797.12,
    y2: 173.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint518_linear_7547_125",
    x1: 5823.02,
    y1: 154.589,
    x2: 5823.02,
    y2: 197.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint519_linear_7547_125",
    x1: 5848.92,
    y1: 186.254,
    x2: 5848.92,
    y2: 225.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint520_linear_7547_125",
    x1: 5874.82,
    y1: 175.965,
    x2: 5874.82,
    y2: 218.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint521_linear_7547_125",
    x1: 5900.73,
    y1: 230.449,
    x2: 5900.73,
    y2: 249.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint522_linear_7547_125",
    x1: 5926.63,
    y1: 201.689,
    x2: 5926.63,
    y2: 241.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint523_linear_7547_125",
    x1: 5438.63,
    y1: 182.295,
    x2: 5438.63,
    y2: 200.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint524_linear_7547_125",
    x1: 5412.72,
    y1: 156.57,
    x2: 5412.72,
    y2: 190.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint525_linear_7547_125",
    x1: 5386.82,
    y1: 129.262,
    x2: 5386.82,
    y2: 179.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint526_linear_7547_125",
    x1: 5360.92,
    y1: 108.019,
    x2: 5360.92,
    y2: 140.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint527_linear_7547_125",
    x1: 5335.02,
    y1: 108.019,
    x2: 5335.02,
    y2: 120.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint528_linear_7547_125",
    x1: 5309.12,
    y1: 83.7447,
    x2: 5309.12,
    y2: 156.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint529_linear_7547_125",
    x1: 5283.22,
    y1: 124.378,
    x2: 5283.22,
    y2: 149.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint530_linear_7547_125",
    x1: 5257.31,
    y1: 91.1326,
    x2: 5257.31,
    y2: 140.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint531_linear_7547_125",
    x1: 5231.41,
    y1: 74.2467,
    x2: 5231.41,
    y2: 124.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint532_linear_7547_125",
    x1: 5205.51,
    y1: 116.464,
    x2: 5205.51,
    y2: 149.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/bb.854dcaa7204e4754c2878cf0dfaab292.svg";
export { ForwardRef as ReactComponent };